<template>
  <div class="team-insights-page">
    <h2 class="page-title">Team Insights</h2>
    <TeamInsightsSkeleton v-if="busy" />
    <ErrorDisplay/>
    <b-row v-show="!busy">
      <b-col xl="12" xs="12">
        <!-- TAB PANEL START -->
        <section class="tab-panel">
          <b-tabs>
            <!-- FIRST TAB START -->
            <b-tab title="Today" active @click="changeTab(1)">
              <div class="info-section">
                  <div class="row">
                      <div :class="(overdueRecallDataDailyByEmp && overdueRecallDataDailyByEmp.length > 0) ? 'col-sm-4 border-right' : 'col-sm-12'">
                        <h5 class="fw-semi-bold">Overdue Recall</h5>
                         <b-card  class="background-cover" v-if="((overdueRecallDataDaily && overdueRecallDataDaily.totalCalls > 0 && allSettings) || (overdueRecallScheduledDataDaily && overdueRecallScheduledDataDaily.length > 0 && allSettings ))">
                            <!--<p class="fs-mini fw-semi-bold">Total calls made: {{overdueRecallDataDaily.totalCalls}} call(s)</p>-->
                            
                            <p class="fs-mini fw-semi-bold">Total follow-ups made: <b-button id="odcalls-daily" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >{{overdueRecallDataDaily.totalCalls}} follow-up(s)</span></b-button></p>
                            <b-popover target="odcalls-daily" triggers="focus" placement="top" v-if="overdueRecallTasksDataDaily && overdueRecallTasksDataDaily.length > 0">
                              <template v-slot:title><b>Follow-up(s) made</b></template>              
                              <table class="table">
                                <thead>
                                  <tr>                                          
                                    <th>Patient</th>                                          
                                    <th>Followed-up on</th>
                                    <th><span class="glyphicon glyphicon-user mr-2 mb-1"></span>Team member</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(appt, index) in overdueRecallTasksDataDaily" :key="`od-${ appt.TeamioPatientID}-${ index }`">                                          
                                    <td>{{formatName(appt.Patient)}}</td>                                          
                                    <td>{{appt.CreatedAt | dateformat(dateFormatStr)}}</td>
                                    <td>{{appt.Employee}}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </b-popover>
                   
                            <p class="fs-mini fw-semi-bold">Total scheduled: 
                              <b-button id="odscheduled-daily" variant="default" class="mb-xs mr-xs btn-xs">
                                <span v-if="( (overdueRecallScheduledDataDaily && overdueRecallScheduledDataDaily.length===0) || (!overdueRecallScheduledDataDaily) )" class="fs-mini fw-semi-bold" >0 appointment(s)</span>
                                <span v-else-if="overdueRecallScheduledDataDaily && overdueRecallScheduledDataDaily.length > 0" class="fs-mini fw-semi-bold" >{{overdueRecallScheduledDataDaily.length}} appointment(s)</span>
                              </b-button>
                              {{sumArrValue(overdueRecallScheduledDataDaily, 'AppointmentValue') | money}}
                            </p>
                            <b-popover target="odscheduled-daily" triggers="focus" placement="top" v-if="overdueRecallScheduledDataDaily && overdueRecallScheduledDataDaily.length > 0">
                              <template v-slot:title><b>Appointment(s) Scheduled</b></template>              
                              <table class="table">
                                <thead>
                                  <tr>                                          
                                    <th>Patient</th>                                          
                                    <th>Appointment Value</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(appt, index) in overdueRecallScheduledDataDaily" :key="`od-${ appt.TeamioPatientID}-${ index }`">                                          
                                    <td>{{formatName(appt.Patient)}}
                                     </td>                                          
                                    <td><span class="text-success fw-semi-bold">{{appt.AppointmentValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td>                                                         
                                  </tr>
                                </tbody>
                              </table>
                            </b-popover>
                            
                           
                            <div class="clearfix fs-mini mt">
                              <span class="pull-right m-0 fw-semi-bold">Daily Goal: <span class="fw-semi-bold">{{this.allSettings.OVERDUE_RECALL_DAILY_CALLS_GOAL.PropertyValue}} follow-ups</span></span>
                              <span class="fs-mini">{{((overdueRecallDataDaily.totalCalls / parseInt(allSettings.OVERDUE_RECALL_DAILY_CALLS_GOAL.PropertyValue,10)) * 100).toFixed(0)}}% of Daily Goal Met</span>
                            </div>
                            <b-progress :max="parseInt(allSettings.OVERDUE_RECALL_DAILY_CALLS_GOAL.PropertyValue,10)" variant="success" class="bg-gray-lighter progress-xs" :value="overdueRecallDataDaily.totalCalls"  />

                            <div class="chart-panel">
                                <PieChart :chartdata="overdueRecallDataDaily.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                            </div>
                        </b-card>
                        <b-card class="background-cover" v-else>
                          <EmptyState :restricted="!$can('view', 'overdue_recall')" subject="overdue_recall" />
                        </b-card>
                      </div>
                      <div class="col-sm-8" v-if="overdueRecallDataDailyByEmp && overdueRecallDataDailyByEmp.length > 0">
                        <h5 class="fw-semi-bold">Breakdown by Team member(s)</h5>
                        <div class="slider-panel slider-panel1 team-member-slider">
                          <b-card  class="background-cover" v-for="(employee, index) in this.overdueRecallDataDailyByEmp" :key="`employee-${index}`">
                              <div class="person-name">
                                  <!--<img data-v-5834cfff="" src="/img/a5.84f014f0.jpg" alt="..." class="rounded-circle">-->
                                  <span class="glyphicon glyphicon-user mr-2"></span>
                                  <div>
                                    <h6>{{employee.name}}</h6>
                                    <p class="fw-semi-bold">{{employee.totalCalls}} Follow-up(s)</p>
                                  </div>
                                </div>                                  
                                <div class="chart-panel">
                                    <PieChart :chartdata="employee.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>                                       
                                </div>
                          </b-card>
                        </div>                          
                      </div>                                   
                  </div>
              </div>
              <div class="info-section">
                  <div class="row">
                      <div :class="(unscheduledTreatmentDataDailyByEmp && unscheduledTreatmentDataDailyByEmp.length > 0) ? 'col-sm-4 border-right' : 'col-sm-12'">
                        <h5 class="fw-semi-bold">Unscheduled Treatment</h5>
                        <b-card  class=" background-cover" v-if="((unscheduledTreatmentDataDaily && unscheduledTreatmentDataDaily.totalCalls > 0 && allSettings) || (unscheduledTreatmentScheduledDataDaily && unscheduledTreatmentScheduledDataDaily.length > 0 && allSettings))">
                          <!--
                          <p class="fs-mini fw-semi-bold">Total calls made: {{unscheduledTreatmentDataDaily.totalCalls}} call(s)</p>
                          -->
                          <p class="fs-mini fw-semi-bold">Total follow-ups made: <b-button id="utcalls-daily" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >{{unscheduledTreatmentDataDaily.totalCalls}} follow-up(s)</span></b-button></p>
                          <b-popover target="utcalls-daily" triggers="focus" placement="top" v-if="unscheduledTreatmentTasksDataDaily && unscheduledTreatmentTasksDataDaily.length > 0">
                              <template v-slot:title><b>Follow-up(s) made</b></template> 
                              <table class="table">
                                <thead>
                                  <tr>                                          
                                    <th>Patient</th>                                          
                                    <th>Followed-up on</th>
                                    <th><span class="glyphicon glyphicon-user mr-2 mb-1"></span>Team member</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(appt, index) in unscheduledTreatmentTasksDataDaily" :key="`od-${ appt.TeamioPatientID}-${ index }`">                                          
                                    <td>{{formatName(appt.Patient)}}</td>                                          
                                    <td>{{appt.CreatedAt | dateformat(dateFormatStr)}}</td>
                                    <td>{{appt.Employee}}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </b-popover>
                          
                          <p class="fs-mini fw-semi-bold">Total scheduled: 
                            <b-button id="utscheduled-daily" variant="default" class="mb-xs mr-xs btn-xs">
                              <span v-if="( (unscheduledTreatmentScheduledDataDaily && unscheduledTreatmentScheduledDataDaily.length===0) || (!unscheduledTreatmentScheduledDataDaily) )" class="fs-mini fw-semi-bold" >0 appointment(s)</span>
                              <span v-else-if="unscheduledTreatmentScheduledDataDaily && unscheduledTreatmentScheduledDataDaily.length > 0" class="fs-mini fw-semi-bold" >{{unscheduledTreatmentScheduledDataDaily.length}} appointment(s)</span>
                            </b-button>
                            {{sumArrValue(unscheduledTreatmentScheduledDataDaily, 'AppointmentValue') | money}}
                          </p>
                          <b-popover target="utscheduled-daily" triggers="focus" placement="top" v-if="unscheduledTreatmentScheduledDataDaily && unscheduledTreatmentScheduledDataDaily.length > 0">
                            <template v-slot:title><b>Appointment(s) Scheduled</b></template>              
                            <table class="table">
                              <thead>
                                <tr>                                          
                                  <th>Patient</th>                                          
                                  <th>Appointment Value</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(appt, index) in unscheduledTreatmentScheduledDataDaily" :key="`od-${ appt.TeamioPatientID}-${ index }`">                                          
                                  <td>{{formatName(appt.Patient)}}
                                  </td>                                          
                                  <td><span class="text-success fw-semi-bold">{{appt.AppointmentValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td>                                                        
                                </tr>
                              </tbody>
                            </table>
                          </b-popover>
                          
                            <div class="clearfix fs-mini mt">
                              <span class="pull-right m-0 fw-semi-bold">Daily Goal: <span class="fw-semi-bold">{{this.allSettings.UNSCHEDULED_TREATMENT_DAILY_CALLS_GOAL.PropertyValue}} follow-ups</span></span>
                              <span class="fs-mini">{{((unscheduledTreatmentDataDaily.totalCalls / parseInt(allSettings.UNSCHEDULED_TREATMENT_DAILY_CALLS_GOAL.PropertyValue,10)) * 100).toFixed(0)}}% of Daily Goal Met</span>
                            </div>
                            <b-progress :max="parseInt(allSettings.UNSCHEDULED_TREATMENT_DAILY_CALLS_GOAL.PropertyValue,10)" variant="success" class="bg-gray-lighter progress-xs" :value="unscheduledTreatmentDataDaily.totalCalls"  />


                            <div class="chart-panel">
                                <PieChart :chartdata="unscheduledTreatmentDataDaily.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                            </div>
                        </b-card>
                        <b-card class="background-cover" v-else>
                          <EmptyState :restricted="!$can('view', 'unscheduled_treatment')" subject="unscheduled_treatment" />
                        </b-card>
                      </div>
                      <div class="col-sm-8" v-if="unscheduledTreatmentDataDailyByEmp && unscheduledTreatmentDataDailyByEmp.length > 0">
                        <h5 class="fw-semi-bold">Breakdown by Team member(s)</h5>
                          <div class="slider-panel slider-panel1 team-member-slider">
                              <b-card  class="background-cover" v-for="(employee, index) in this.unscheduledTreatmentDataDailyByEmp" :key="`employee-${index}`">
                                  <div class="person-name">
                                      <!--<img data-v-5834cfff="" src="/img/a5.84f014f0.jpg" alt="..." class="rounded-circle">-->
                                      <span class="glyphicon glyphicon-user mr-2"></span>
                                      <div>
                                        <h6>{{employee.name}}</h6>
                                        <p class="fw-semi-bold">{{employee.totalCalls}} Follow-up(s)</p>
                                      </div>
                                    </div>
                                    <div class="chart-panel">
                                        <PieChart :chartdata="employee.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>                                       
                                    </div>
                              </b-card>
                          </div>                          
                      </div>  
                  </div>
              </div> 
              <div class="info-section">              
                  <div class="row">                  
                      <div class="col-sm-12">
                        <h3 class="fw-semi-bold">Aging</h3>
                        <div class="inner-tab mt-4">
                            <b-tabs>
                                <b-tab title="Outstanding Claims" active>
                                  <div class="row">
                                      <div :class="(outstandingClaimsDataDailyByEmp && outstandingClaimsDataDailyByEmp.length > 0) ? 'col-sm-4' : 'col-sm-12'">
                                        <b-card  class="background-cover" v-if="((outstandingClaimsDataDaily && outstandingClaimsDataDaily.totalCalls > 0) || (outstandingClaimsClaimReceivedDataDaily && outstandingClaimsClaimReceivedDataDaily.length > 0))">
                                                  
                                                  <!--
                                                  <p class="fs-mini fw-semi-bold">Total calls made: {{outstandingClaimsDataDaily.totalCalls}} call(s)</p>
                                                  -->
                                                  <p class="fs-mini fw-semi-bold">Total calls made: <b-button id="occalls-daily" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >{{outstandingClaimsDataDaily.totalCalls}} call(s)</span></b-button></p>

                                                  <b-popover target="occalls-daily" triggers="focus" placement="top" v-if="outstandingClaimsTasksDataDaily && outstandingClaimsTasksDataDaily.length > 0">
                                                    <template v-slot:title><b>Call(s) made</b></template>              
                                                    <table class="table">
                                                      <thead>
                                                        <tr>                                          
                                                          <th>For Patient</th>                                          
                                                          <th>Called on</th>
                                                          <th><span class="glyphicon glyphicon-user mr-2 mb-1"></span>Team member</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        <tr v-for="(appt, index) in outstandingClaimsTasksDataDaily" :key="`oc-${ appt.TeamioPatientID}-${ index }`">                                          
                                                          <td>{{formatName(appt.Patient)}}</td>                                          
                                                          <td>{{appt.CreatedAt | dateformat(dateFormatStr)}}</td>
                                                          <td>{{appt.Employee}}</td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </b-popover>

                                                  <p class="fs-mini fw-semi-bold">Claims received from follow-ups: 
                                                    <b-button id="ocschedule-daily" variant="default" class="mb-xs mr-xs btn-xs">
                                                      <span v-if="( (outstandingClaimsClaimReceivedDataDaily && outstandingClaimsClaimReceivedDataDaily.length===0) || (!outstandingClaimsClaimReceivedDataDaily) )" class="fs-mini fw-semi-bold" >0 claim(s) </span>
                                                      <span v-else-if="outstandingClaimsClaimReceivedDataDaily && outstandingClaimsClaimReceivedDataDaily.length > 0" class="fs-mini fw-semi-bold" >{{outstandingClaimsClaimReceivedDataDaily.length}} claim(s) </span>
                                                    </b-button>
                                                  </p>
                                                  <b-popover target="ocschedule-daily" triggers="focus" placement="top" v-if="outstandingClaimsClaimReceivedDataDaily && outstandingClaimsClaimReceivedDataDaily.length > 0">
                                                    <template v-slot:title><b>Claim(s) Received</b></template>              
                                                    <table class="table">
                                                      <thead>
                                                        <tr>                                          
                                                          <th>Patient</th>                                          
                                                          <th>Claim Received</th>
                                                          <th>Insurance Paid Amt</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        <tr v-for="(appt, index) in outstandingClaimsClaimReceivedDataDaily" :key="`od-${ appt.TeamioPatientID}-${ index }`">                                          
                                                          <td>{{formatName(appt.Patient)}}
                                                           
                                                          </td>                                          
                                                          <td>{{appt.UpdatedAt | dateformat(dateFormatStr)}}</td>
                                                          <td><span class="text-success fw-semi-bold">{{appt.ClaimValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td>                                                       
                                                        
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </b-popover>
                                                                                
                                              <div class="chart-panel">
                                                <PieChart :chartdata="outstandingClaimsDataDaily.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                                              </div>
                                        </b-card>
                                        <b-card class="background-cover" v-else>
                                          <EmptyState :restricted="!$can('view', 'outstanding_claim')" subject="outstanding_claim" />
                                        </b-card>
                                      </div>
                                      <div class="col-sm-8" v-if="outstandingClaimsDataDailyByEmp && outstandingClaimsDataDailyByEmp.length > 0">
                                        <h5 class="fw-semi-bold">Breakdown by Team member(s)</h5>
                                        <div class="slider-panel slider-panel1 team-member-slider">
                                            <b-card  class="background-cover" v-for="(employee, index) in this.outstandingClaimsDataDailyByEmp" :key="`employee-${index}`">
                                                <div class="person-name">
                                                    <!--<img data-v-5834cfff="" src="/img/a5.84f014f0.jpg" alt="..." class="rounded-circle">-->
                                                    <span class="glyphicon glyphicon-user mr-2"></span>
                                                    <div>
                                                      <h6>{{employee.name}}</h6>
                                                      <p class="fw-semi-bold">{{employee.totalCalls}} Call(s)</p>
                                                    </div>
                                                  </div>
                                                  <div class="chart-panel">
                                                      <PieChart v-if="currentTab===1" :chartdata="employee.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                                                  </div>
                                            </b-card>
                                        </div>                          
                                      </div> 
                                  </div>
                                </b-tab>  
                                <b-tab title="Pre-authorizations" @click="initialiseSlider">
                                    <div class="row mb-2">
                                        <div :class="(preAuthOutstandingDataDailyByEmp && preAuthOutstandingDataDailyByEmp.length > 0) ? 'col-sm-4 border-right' : 'col-sm-12'">
                                         <h5 class="fw-semi-bold">Outstanding PreAuthorizations</h5>
                                          <b-card  class="background-cover" v-if="((preAuthOutstandingDataDaily && preAuthOutstandingDataDaily.totalCalls > 0) || (preAuthOutstandingClaimReceivedDataDaily && preAuthOutstandingClaimReceivedDataDaily.length > 0))"> 

                                                    <!--
                                                    <p class="fs-mini fw-semi-bold">Total calls made: {{preAuthOutstandingDataDaily.totalCalls}} call(s)</p>
                                                    -->
                                                    <p class="fs-mini fw-semi-bold">Total calls made: <b-button id="opcalls-daily" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >{{preAuthOutstandingDataDaily.totalCalls}} call(s)</span></b-button></p>
                                                    <b-popover target="opcalls-daily" triggers="focus" placement="top" v-if="preAuthOutstandingTasksDataDaily && preAuthOutstandingTasksDataDaily.length > 0">
                                                      <template v-slot:title><b>Call(s) made</b></template>              
                                                      <table class="table">
                                                        <thead>
                                                          <tr>                                          
                                                            <th>For Patient</th>                                          
                                                            <th>Called on</th>
                                                            <th><span class="glyphicon glyphicon-user mr-2 mb-1"></span>Team member</th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          <tr v-for="(appt, index) in preAuthOutstandingTasksDataDaily" :key="`po-${ appt.TeamioPatientID}-${ index }`">                                          
                                                            <td>{{formatName(appt.Patient)}}</td>                                          
                                                            <td>{{appt.CreatedAt | dateformat(dateFormatStr)}}</td>
                                                            <td>{{appt.Employee}}</td>
                                                          </tr>
                                                        </tbody>
                                                      </table>
                                                    </b-popover>
                                                    <p class="fs-mini fw-semi-bold">Claims received from follow-ups: 
                                                      <b-button id="opschedule-daily" variant="default" class="mb-xs mr-xs btn-xs">
                                                        <span v-if="( (preAuthOutstandingClaimReceivedDataDaily && preAuthOutstandingClaimReceivedDataDaily.length===0) || (!preAuthOutstandingClaimReceivedDataDaily) )" class="fs-mini fw-semi-bold" >0 claim(s)</span>
                                                        <span v-else-if="preAuthOutstandingClaimReceivedDataDaily && preAuthOutstandingClaimReceivedDataDaily.length > 0" class="fs-mini fw-semi-bold" >{{preAuthOutstandingClaimReceivedDataDaily.length}} claim(s) </span>
                                                      </b-button>
                                                    </p>
                                                    <b-popover target="opschedule-daily" triggers="focus" placement="top" v-if="preAuthOutstandingClaimReceivedDataDaily && preAuthOutstandingClaimReceivedDataDaily.length > 0">
                                                      <template v-slot:title><b>Claim(s) Received</b></template>              
                                                      <table class="table">
                                                        <thead>
                                                          <tr>                                          
                                                            <th>Patient</th>                                          
                                                            <th>Claim Received</th>
                                                            <th>Insurance Estimate</th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          <tr v-for="(appt, index) in preAuthOutstandingClaimReceivedDataDaily" :key="`od-${ appt.TeamioPatientID}-${ index }`">                                          
                                                            <td>{{formatName(appt.Patient)}}
                                                              
                                                            </td>                                          
                                                            <td>{{appt.UpdatedAt | dateformat(dateFormatStr)}}</td>
                                                            <td><span class="fw-semi-bold text-success">{{appt.ClaimValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td> 

                                                          </tr>
                                                        </tbody>
                                                      </table>
                                                    </b-popover>                                                    
                                                                         
                                                <div class="chart-panel">
                                                    <PieChart :chartdata="preAuthOutstandingDataDaily.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                                                </div>
                                          </b-card>
                                          <b-card class="background-cover" v-else>
                                            <EmptyState :restricted="!$can('view', 'outstanding_preauths')" subject="outstanding_preauths" />
                                          </b-card>
                                        </div>
                                        <div class="col-sm-8" v-if="preAuthOutstandingDataDailyByEmp && preAuthOutstandingDataDailyByEmp.length > 0">
                                          <h5 class="fw-semi-bold">Breakdown by Team member(s)</h5>
                                          <div class="slider-panel slider-panel1 team-member-slider">
                                            <b-card  class="background-cover" v-for="(employee, index) in this.preAuthOutstandingDataDailyByEmp" :key="`employee-${index}`">
                                              <div class="person-name">
                                                  <!--<img data-v-5834cfff="" src="/img/a5.84f014f0.jpg" alt="..." class="rounded-circle">-->
                                                  <span class="glyphicon glyphicon-user mr-2"></span>
                                                  <div>
                                                    <h6>{{employee.name}}</h6>
                                                    <p class="fw-semi-bold">{{employee.totalCalls}} Call(s)</p>
                                                  </div>
                                              </div>
                                              <div class="chart-panel">
                                                  <PieChart v-if="currentTab===1" :chartdata="employee.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                                              </div>
                                            </b-card>
                                          </div>                          
                                        </div>
                                    </div>
                                    <!--
                                    <div class="row mt-4">                    
                                        <div class="col-sm-4 border-right">
                                          <h5 class="fw-semi-bold">Received PreAuthorizations</h5>
                                          <b-card class=" background-cover" v-if="((preAuthReceivedDataDaily && preAuthReceivedDataDaily.totalCalls > 0) || (preAuthReceivedScheduledDataDaily && preAuthReceivedScheduledDataDaily.length > 0))">
                                                    <p class="fs-mini fw-semi-bold">Total calls made: <b-button id="pacalls-daily" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >{{preAuthReceivedDataDaily.totalCalls}} call(s)</span></b-button></p>
                                                    <b-popover target="pacalls-daily" triggers="focus" placement="top" v-if="preAuthReceivedTasksDataDaily && preAuthReceivedTasksDataDaily.length > 0">
                                                      <template v-slot:title><b>Call(s) made</b></template>              
                                                      <table class="table">
                                                        <thead>
                                                          <tr>                                          
                                                            <th>Patient</th>                                          
                                                            <th>Called on</th>
                                                            <th><span class="glyphicon glyphicon-user mr-2 mb-1"></span>Team member</th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          <tr v-for="(appt, index) in preAuthReceivedTasksDataDaily" :key="`od-${ appt.TeamioPatientID}-${ index }`">                                          
                                                            <td>{{formatName(appt.Patient)}}</td>                                          
                                                            <td>{{appt.CreatedAt | dateformat(dateFormatStr)}}</td>
                                                            <td>{{appt.Employee}}</td>
                                                          </tr>
                                                        </tbody>
                                                      </table>
                                                    </b-popover>

                                                    <p class="fs-mini fw-semi-bold">Total scheduled: 
                                                      <b-button id="pascheduled-daily" variant="default" class="mb-xs mr-xs btn-xs">
                                                        <span v-if="( (preAuthReceivedScheduledDataDaily && preAuthReceivedScheduledDataDaily.length===0) || (!preAuthReceivedScheduledDataDaily) )" class="fs-mini fw-semi-bold" >0 appointment(s)</span>
                                                        <span v-else-if="preAuthReceivedScheduledDataDaily && preAuthReceivedScheduledDataDaily.length > 0" class="fs-mini fw-semi-bold" >{{preAuthReceivedScheduledDataDaily.length}} appointment(s)</span>
                                                      </b-button>
                                                    </p>
                                                    <b-popover target="pascheduled-daily" triggers="focus" placement="top" v-if="preAuthReceivedScheduledDataDaily && preAuthReceivedScheduledDataDaily.length > 0">
                                                      <template v-slot:title><b>Appointment(s) Scheduled</b></template>              
                                                      <table class="table">
                                                        <thead>
                                                          <tr>                                          
                                                            <th>Patient</th>                                          
                                                            <th>Appointment Value</th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          <tr v-for="(appt, index) in preAuthReceivedScheduledDataDaily" :key="`od-${ appt.TeamioPatientID}-${ index }`">                                          
                                                            <td>{{formatName(appt.Patient)}}
                                                           </td>                                          
                                                            <td><span class="text-success fw-semi-bold">{{appt.AppointmentValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td>                                                        
                                                          </tr>
                                                        </tbody>
                                                      </table>
                                                    </b-popover>
                                              <div class="chart-panel">
                                                  <PieChart :chartdata="preAuthReceivedDataDaily.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                                              </div>
                                          </b-card>
                                          <b-card  class="background-cover"  v-else>
                                            <div>
                                            
                                            <div class="empty-state">
                              <div class="empty-state-icon">
                                <i class="fa fa-bar-chart"></i>
                              </div>
                              <div class="empty-state-title">No Data Available</div>
                              <div class="empty-state-text">Data will appear once activity is recorded</div>
                            </div>
                                            </div>
                                          </b-card>
                                        </div>
                                        <div class="col-sm-8" v-if="preAuthReceivedDataDailyByEmp && preAuthReceivedDataDailyByEmp.length > 0">
                                          <h5 class="fw-semi-bold">Breakdown by Team member(s)</h5>
                                          <div class="slider-panel slider-panel1 team-member-slider">
                                            <b-card  class="background-cover" v-for="(employee, index) in this.preAuthReceivedDataDailyByEmp" :key="`employee-${index}`">
                                                <div class="person-name">
                                                    <span class="glyphicon glyphicon-user mr-2"></span>
                                                    <div>
                                                      <h6>{{employee.name}}</h6>
                                                      <p class="fw-semi-bold">{{employee.totalCalls}} Call(s)</p>
                                                    </div>
                                                  </div>                                  
                                                  <div class="chart-panel">
                                                      <PieChart :chartdata="employee.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>                                       
                                                  </div>
                                            </b-card>
                                          </div>                          
                                        </div>                               
                                   </div>
                                   -->
                                </b-tab> 
                                <b-tab title="Patient Balances">
                                  <div class="row">
                                    <div :class="(patientBalancesDataDailyByEmp && patientBalancesDataDailyByEmp.length > 0) ? 'col-sm-4' : 'col-sm-12'">
                                      <h5 class="fw-semi-bold">Collection Follow-ups</h5>

                                      <b-card  class="background-cover" v-if="((patientBalancesDataDaily && patientBalancesDataDaily.totalCalls > 0) )">
                                      <!--
                                        <b-card  class="background-cover" v-if="((patientBalancesDataDaily && patientBalancesDataDaily.totalCalls > 0) )">
                                      -->
                                          <p class="fs-mini fw-semi-bold">Patient Collection follow-ups made: <b-button id="pbcalls-daily" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >{{patientBalancesDataDaily.totalCalls}} follow-up(s)</span></b-button></p>
                                          <b-popover target="pbcalls-daily" triggers="focus" placement="top" v-if="patientBalancesTasksDataDaily && patientBalancesTasksDataDaily.length > 0">
                                          <template v-slot:title><b>Follow-up(s) made</b></template>              
                                          <table class="table">
                                            <thead>
                                              <tr>                                          
                                                <th>Patient</th>                                          
                                                <th>Followed-up on</th>
                                                <th><span class="glyphicon glyphicon-user mr-2 mb-1"></span>Team member</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr v-for="(appt, index) in patientBalancesTasksDataDaily" :key="`od-${ appt.TeamioPatientID}-${ index }`">                                          
                                                <td>{{formatName(appt.Patient)}}</td>                                          
                                                <td>{{appt.CreatedAt | dateformat(dateFormatStr)}}</td>
                                                <td>{{appt.Employee}}</td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </b-popover>
                                         
                                        <!--
                                        <p class="fs-mini fw-semi-bold" v-if="patientBalancesPaidSumDaily">Collected from Follow-up(s): 
                                            <b-button id="pbcollectdaily" variant="default" class="mb-xs mr-xs btn-xs">
                                              <span class="fs-mini fw-semi-bold" >{{patientBalancesPaidSumDaily | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
                                            </b-button>
                                          </p>
                                          <b-popover target="pbcollectdaily" triggers="focus" placement="top" v-if="patientBalancesPaidDaily && patientBalancesPaidDaily.length > 0">
                                            <template v-slot:title><b>Payment(s) Collected</b></template>
                                            <p>
                                              <span class="fw-semi-bold">Total collected</span>  - is the cumulative amount the patient has paid upto most recept payment date since your first follow-up for the balance on the account.  
                                            </p>
                                            <table class="table">
                                              <thead>
                                                <tr>                                          
                                                  <th>Patient</th>                                          
                                                  <th>Total Collected</th>
                                                  <th>Most recent payment date</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                <tr v-for="(appt, index) in patientBalancesPaidDaily" :key="`pbcd-${ appt.TeamioPatientID}-${ index }`">                                          
                                                  <td>{{formatName(appt.Patient)}}</td>
                                                  <td><span class="fw-semi-bold text-success">{{appt.PatientBalanceAmountPaid | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td>                                               
                                                  <td>{{appt.MostRecentBalancePaidDate | dateformat(dateFormatStr)}}</td>                                                                                                      
                                                </tr>
                                              </tbody>
                                            </table>
                                          </b-popover>
                                        -->
                                        
                                          <div class="chart-panel">
                                            <PieChart :chartdata="patientBalancesDataDaily.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                                          </div>
                                      </b-card>
                                      <b-card class="background-cover" v-else>
                                          <EmptyState :restricted="!$can('view', 'patient_balances')" subject="patient_balances" />
                                        </b-card>
                                    </div>
                                    <div class="col-sm-8" v-if="patientBalancesDataDailyByEmp && patientBalancesDataDailyByEmp.length > 0">
                                      <h5 class="fw-semi-bold">Breakdown by Team member(s)</h5>
                                      <div class="slider-panel slider-panel1 team-member-slider">
                                        <b-card  class="background-cover" v-for="(employee, index) in this.patientBalancesDataDailyByEmp" :key="`employee-${index}`">
                                          <div class="person-name">
                                            <!-- <img data-v-5834cfff="" src="/img/a5.84f014f0.jpg" alt="..." class="rounded-circle">-->
                                            <span class="glyphicon glyphicon-user mr-2"></span>
                                            <div>
                                              <h6>{{employee.name}}</h6>
                                              <p class="fw-semi-bold">{{employee.totalCalls}} Call(s)</p>
                                            </div>
                                          </div>
                                          <div class="chart-panel">       
                                            <PieChart v-if="currentTab===1" :chartdata="employee.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                                          </div>
                                        </b-card>
                                      </div>
                                    </div> 
                                  </div>  
                                </b-tab>  
                            </b-tabs>
                        </div>                                                
                      </div>                           
                  </div>
              </div> 
              <div class="info-section">
                  <div class="row">
                      <div :class="(brokenAppointmentDataDailyByEmp && brokenAppointmentDataDailyByEmp.length > 0) ? 'col-sm-4 border-right' : 'col-sm-12'">
                        <h5 class="fw-semi-bold">Broken Appointment Follow-ups</h5>
                        <b-card  class="background-cover" v-if="((brokenAppointmentDataDaily && brokenAppointmentDataDaily.totalCalls > 0) || (brokenAppointmentScheduledDataDaily && brokenAppointmentScheduledDataDaily.length > 0))">
                            <!--
                            <p class="fs-mini fw-semi-bold">Total calls made: {{brokenAppointmentDataDaily.totalCalls}} call(s)</p>
                            -->
                            <p class="fs-mini fw-semi-bold">Total follow-ups made: <b-button id="bacalls-daily" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >{{brokenAppointmentDataDaily.totalCalls}} follow-up(s)</span></b-button></p>

                            <b-popover target="bacalls-daily" triggers="focus" placement="top" v-if="brokenAppointmentTasksDataDaily && brokenAppointmentTasksDataDaily.length > 0">
                              <template v-slot:title><b>Follow-up(s) made</b></template>              
                              <table class="table">
                                <thead>
                                  <tr>                                          
                                    <th>Patient</th>                                          
                                    <th>Followed-up on</th>
                                    <th><span class="glyphicon glyphicon-user mr-2 mb-1"></span>Team member</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(appt, index) in brokenAppointmentTasksDataDaily" :key="`od-${ appt.TeamioPatientID}-${ index }`">                                          
                                    <td>{{formatName(appt.Patient)}}</td>                                          
                                    <td>{{appt.CreatedAt | dateformat(dateFormatStr)}}</td>
                                    <td>{{appt.Employee}}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </b-popover>

                            <p class="fs-mini fw-semi-bold">Total scheduled: 
                              <b-button id="bascheduled-daily" variant="default" class="mb-xs mr-xs btn-xs">                                
                                <span v-if="( (brokenAppointmentScheduledDataDaily && brokenAppointmentScheduledDataDaily.length===0) || (!brokenAppointmentScheduledDataDaily) )" class="fs-mini fw-semi-bold" >0 appointment(s)</span>
                                <span v-else-if="brokenAppointmentScheduledDataDaily && brokenAppointmentScheduledDataDaily.length > 0" class="fs-mini fw-semi-bold" >{{brokenAppointmentScheduledDataDaily.length}} appointment(s)</span>
                              </b-button>
                              {{sumArrValue(brokenAppointmentScheduledDataDaily, 'AppointmentValue') | money}}
                            </p>
                            <b-popover target="bascheduled-daily" triggers="focus" placement="top" v-if="brokenAppointmentScheduledDataDaily && brokenAppointmentScheduledDataDaily.length > 0">
                              <template v-slot:title><b>Appointment(s) Scheduled</b></template>              
                              <table class="table">
                                <thead>
                                  <tr>                                          
                                    <th>Patient</th>                                          
                                    <th>Appointment Value</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(appt, index) in brokenAppointmentScheduledDataDaily" :key="`badaily-${ appt.TeamioPatientID}-${ index }`">                                          
                                    <td>{{formatName(appt.Patient)}}
                                    </td>                                          
                                    <td><span class="text-success fw-semi-bold">{{appt.AppointmentValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td>                                                         
                                  </tr>
                                </tbody>
                              </table>
                            </b-popover>
                     
                            <div class="chart-panel">
                              <PieChart :chartdata="brokenAppointmentDataDaily.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                            </div>
                        </b-card>
                        <b-card class="background-cover" v-else>
                          <EmptyState :restricted="!$can('view', 'broken_appointment')" subject="broken_appointment" />
                        </b-card>
                      </div>
                      <div class="col-sm-8" v-if="brokenAppointmentDataDailyByEmp && brokenAppointmentDataDailyByEmp.length > 0">
                          <h5 class="fw-semi-bold">Breakdown by Team member(s)</h5>
                          <div class="slider-panel slider-panel2 team-member-slider">
                              <b-card  class="background-cover" v-for="(employee, index) in this.brokenAppointmentDataDailyByEmp" :key="`employee-${index}`">
                                  <div class="person-name">
                                      <!--<img data-v-5834cfff="" src="/img/a5.84f014f0.jpg" alt="..." class="rounded-circle">-->
                                      <span class="glyphicon glyphicon-user mr-2"></span>
                                      <div>
                                        <h6>{{employee.name}}</h6>
                                        <p class="fw-semi-bold">{{employee.totalCalls}} Follow-up(s)</p>
                                      </div>
                                    </div>                                  
                                    <div class="chart-panel">
                                       <PieChart :chartdata="employee.chartData" :options="chartOptions" :styles="chartStyles"/>
                                    </div>
                              </b-card>
                          </div>                          
                        </div>                                   
                  </div>
              </div>  
              <!--
              <div class="info-section">              
                  <div class="row">                  
                      <div class="col-sm-4">
                        <h6 class="text-success fw-semi-bold">Insurance Verifications <sup class="ml-1 headerLabel text-danger">Coming soon!</sup></h6>
                        <b-card  class=" background-cover">
                            <div class="person-name">
                                <div>
                                  <h6>3 Verified</h6>
                                </div>
                              </div>                                  
                              <div class="chart-panel">
                                   <BarsChart v-if="currentTab==1" :chartData="getTodayInsuranceVerificationChartData"/>
                              </div>
                        </b-card>
                      </div>                           
                  </div>
              </div>     
              -->
            </b-tab>
            <!-- FIRST TAB END -->
            <!-- SECOND TAB START -->
            <b-tab title="Week-to-Date" @click="changeTab(2)">
                <div class="info-section">
                    <div class="row">
                        <div :class="(overdueRecallDataWeeklyByEmp && overdueRecallDataWeeklyByEmp.length > 0) ? 'col-sm-4 border-right' : 'col-sm-12'">
                          <h5 class="fw-semi-bold">Overdue Recall</h5>
                          <b-card  class="background-cover" v-if="((overdueRecallDataWeekly && overdueRecallDataWeekly.totalCalls > 0 && allSettings) || (overdueRecallScheduledDataWeekly && overdueRecallScheduledDataWeekly.length > 0 && allSettings ))">
                              <!--
                              <p class="fs-mini fw-semi-bold">Total calls made: {{overdueRecallDataWeekly.totalCalls}} call(s)</p>
                              -->
                              <p class="fs-mini fw-semi-bold">Total follow-ups made: <b-button id="odcalls-weekly" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >{{overdueRecallDataWeekly.totalCalls}} follow-up(s)</span></b-button></p>
                              
                              <b-popover target="odcalls-weekly" triggers="focus" placement="top" v-if="overdueRecallTasksDataWeekly && overdueRecallTasksDataWeekly.length > 0">
                              <template v-slot:title><b>Follow-up(s) made</b></template>              
                              <table class="table">
                                <thead>
                                  <tr>                                          
                                    <th>Patient</th>                                          
                                    <th>Followed-up on</th>
                                    <th><span class="glyphicon glyphicon-user mr-2 mb-1"></span>Team member</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(appt, index) in overdueRecallTasksDataWeekly" :key="`odw-${ appt.TeamioPatientID}-${ index }`">                                          
                                    <td>{{formatName(appt.Patient)}}</td>                                          
                                    <td>{{appt.CreatedAt | dateformat(dateFormatStr)}}</td>
                                    <td>{{appt.Employee}}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </b-popover>
                              <p class="fs-mini fw-semi-bold">Total scheduled: 
                                <b-button id="odw" variant="default" class="mb-xs mr-xs btn-xs">
                                  <span v-if="( (overdueRecallScheduledDataWeekly && overdueRecallScheduledDataWeekly.length===0) || (!overdueRecallScheduledDataWeekly) )" class="fs-mini fw-semi-bold" >0 appointment(s)</span>
                                  <span v-else-if="overdueRecallScheduledDataWeekly && overdueRecallScheduledDataWeekly.length > 0" class="fs-mini fw-semi-bold" >{{overdueRecallScheduledDataWeekly.length}} appointment(s)</span>
                                </b-button>
                                {{sumArrValue(overdueRecallScheduledDataWeekly, 'AppointmentValue') | money}}
                              </p>
                              <b-popover target="odw" triggers="focus" placement="top" v-if="overdueRecallScheduledDataWeekly && overdueRecallScheduledDataWeekly.length > 0">
                                <template v-slot:title><b>Appointment(s) Scheduled</b></template>              
                                <table class="table">
                                  <thead>
                                    <tr>                                          
                                      <th>Patient</th>                                          
                                      <th>Appointment Value</th>
                                      <th>Created on</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(appt, index) in overdueRecallScheduledDataWeekly" :key="`odw-${ appt.TeamioPatientID}-${ index }`">                                          
                                      <td>{{formatName(appt.Patient)}}
                                      </td>                                          
                                      <td><span class="text-success fw-semi-bold">{{appt.AppointmentValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td>
                                      <td>{{appt.UpdatedAt | dateformat(dateFormatStr)}}</td>                                                        
                                    </tr>
                                  </tbody>
                                </table>
                              </b-popover>
                              
                               <div class="clearfix fs-mini mt">
                                <span class="pull-right m-0 fw-semi-bold">Weekly Goal: <span class="fw-semi-bold">{{this.allSettings.OVERDUE_RECALL_WEEKLY_CALLS_GOAL.PropertyValue}} follow-ups</span></span>
                                <span class="fs-mini">{{((overdueRecallDataWeekly.totalCalls / parseInt(allSettings.OVERDUE_RECALL_WEEKLY_CALLS_GOAL.PropertyValue,10)) * 100).toFixed(0)}}% of Weekly Goal Met</span>
                              </div>
                              <b-progress :max="parseInt(allSettings.OVERDUE_RECALL_WEEKLY_CALLS_GOAL.PropertyValue,10)" variant="success" class="bg-gray-lighter progress-xs" :value="overdueRecallDataWeekly.totalCalls"  />

                              <div class="chart-panel">
                                  <PieChart :chartdata="overdueRecallDataWeekly.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                              </div>
                          </b-card>
                          <b-card class="background-cover" v-else>
                            <EmptyState :restricted="!$can('view', 'overdue_recall')" subject="overdue_recall" />
                          </b-card>
                        </div>
                        <div class="col-sm-8" v-if="overdueRecallDataWeeklyByEmp && overdueRecallDataWeeklyByEmp.length > 0">
                            <h5 class="fw-semi-bold">Breakdown by Team member(s)</h5>
                            <div class="slider-panel slider-panel3 team-member-slider">
                                <b-card  class="background-cover" v-for="(employee, index) in this.overdueRecallDataWeeklyByEmp" :key="`employee-${index}`">
                                    <div class="person-name">
                                        <!--<img data-v-5834cfff="" src="/img/a5.84f014f0.jpg" alt="..." class="rounded-circle">-->
                                        <span class="glyphicon glyphicon-user mr-2"></span>
                                        <div>
                                          <h6>{{employee.name}}</h6>
                                          <p class="fw-semi-bold">{{employee.totalCalls}} follow-up(s) - {{employee.conversionRate}}% Conversion Rate</p>
                                        </div>
                                      </div>                                  
                                      <div class="chart-panel">                                                                           
                                        <ChartJSBarChart v-if="currentTab==2 && employee.chartData" :chartData="transformBarChartData(employee.chartData)" />
                                      </div>
                                </b-card>
                            </div>                          
                          </div>                                   
                    </div>
                </div>
                <div class="info-section">
                    <div class="row">
                        <div :class="(unscheduledTreatmentDataWeeklyByEmp && unscheduledTreatmentDataWeeklyByEmp.length > 0) ? 'col-sm-4 border-right' : 'col-sm-12'">
                          <h5 class="fw-semi-bold">Unscheduled Treatment</h5>
                          <b-card  class=" background-cover" v-if="((unscheduledTreatmentDataWeekly && unscheduledTreatmentDataWeekly.totalCalls > 0 && allSettings) || (unscheduledTreatmentScheduledDataWeekly && unscheduledTreatmentScheduledDataWeekly.length > 0 && allSettings ))">
                              <!--
                              <p class="fs-mini fw-semi-bold">Total calls made: {{unscheduledTreatmentDataWeekly.totalCalls}} call(s)</p>
                              -->
                              <p class="fs-mini fw-semi-bold">Total follow-ups made: <b-button id="utcalls-weekly" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >{{unscheduledTreatmentDataWeekly.totalCalls}} follow-up(s)</span></b-button></p>
                              <b-popover target="utcalls-weekly" triggers="focus" placement="top" v-if="unscheduledTreatmentTasksDataWeekly && unscheduledTreatmentTasksDataWeekly.length > 0">
                                <template v-slot:title><b>Follow-up(s) made</b></template> 
                                  <table class="table">
                                    <thead>
                                      <tr>                                          
                                        <th>Patient</th>                                          
                                        <th>Followed-up on</th>
                                        <th><span class="glyphicon glyphicon-user mr-2 mb-1"></span>Team member</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(appt, index) in unscheduledTreatmentTasksDataWeekly" :key="`od-${ appt.TeamioPatientID}-${ index }`">                                          
                                        <td>{{formatName(appt.Patient)}}</td>                                          
                                        <td>{{appt.CreatedAt | dateformat(dateFormatStr)}}</td>
                                        <td>{{appt.Employee}}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                              </b-popover>

                              <p class="fs-mini fw-semi-bold">Total scheduled: 
                                <b-button id="utw" variant="default" class="mb-xs mr-xs btn-xs">
                                  <span v-if="( (unscheduledTreatmentScheduledDataWeekly && unscheduledTreatmentScheduledDataWeekly.length===0) || (!unscheduledTreatmentScheduledDataWeekly) )" class="fs-mini fw-semi-bold" >0 appointment(s)</span>
                                  <span v-else-if="unscheduledTreatmentScheduledDataWeekly && unscheduledTreatmentScheduledDataWeekly.length > 0" class="fs-mini fw-semi-bold" >{{unscheduledTreatmentScheduledDataWeekly.length}} appointment(s)</span>
                                </b-button>
                                {{sumArrValue(unscheduledTreatmentScheduledDataWeekly, 'AppointmentValue') | money}}
                              </p>
                              
                              <b-popover target="utw" triggers="focus" placement="top" v-if="unscheduledTreatmentScheduledDataWeekly && unscheduledTreatmentScheduledDataWeekly.length > 0">
                                <template v-slot:title><b>Appointment(s) Scheduled</b></template>              
                                <table class="table">
                                  <thead>
                                    <tr>                                          
                                      <th>Patient</th>                                          
                                      <th>Appointment Value</th>
                                      <th>Created on</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(appt, index) in unscheduledTreatmentScheduledDataWeekly" :key="`utw-${ appt.TeamioPatientID}-${ index }`">                                          
                                      <td>{{formatName(appt.Patient)}}
                                        
                                      </td>                                          
                                      <td><span class="text-success fw-semi-bold">{{appt.AppointmentValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td>
                                      <td>{{appt.UpdatedAt | dateformat(dateFormatStr)}}</td>                                                          
                                    </tr>
                                  </tbody>
                                </table>
                              </b-popover> 
                              
                              <div class="clearfix fs-mini mt">
                                <span class="pull-right m-0 fw-semi-bold">Weekly Goal: <span class="fw-semi-bold">{{this.allSettings.UNSCHEDULED_TREATMENT_WEEKLY_CALLS_GOAL.PropertyValue}} follow-ups</span></span>
                                <span class="fs-mini">{{((unscheduledTreatmentDataWeekly.totalCalls / parseInt(allSettings.UNSCHEDULED_TREATMENT_WEEKLY_CALLS_GOAL.PropertyValue,10)) * 100).toFixed(0)}}% of Weekly Goal Met</span>
                              </div>
                              <b-progress :max="parseInt(allSettings.UNSCHEDULED_TREATMENT_WEEKLY_CALLS_GOAL.PropertyValue,10)" variant="success" class="bg-gray-lighter progress-xs" :value="unscheduledTreatmentDataWeekly.totalCalls"  />

                              <div class="chart-panel">
                                  <PieChart :chartdata="unscheduledTreatmentDataWeekly.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                              </div>
                          </b-card>
                          <b-card class="background-cover" v-else>
                            <EmptyState :restricted="!$can('view', 'unscheduled_treatment')" subject="unscheduled_treatment" />
                          </b-card>
                        </div>
                        <div class="col-sm-8" v-if="unscheduledTreatmentDataWeeklyByEmp && unscheduledTreatmentDataWeeklyByEmp.length > 0">
                          <h5 class="fw-semi-bold">Breakdown by Team member(s)</h5>
                          <div class="slider-panel slider-panel3 team-member-slider">
                            <b-card  class=" background-cover" v-for="(employee, index) in this.unscheduledTreatmentDataWeeklyByEmp" :key="`employee-${index}`">
                                <div class="person-name">
                                    <!--<img data-v-5834cfff="" src="/img/a5.84f014f0.jpg" alt="..." class="rounded-circle">-->
                                    <span class="glyphicon glyphicon-user mr-2"></span>
                                    <div>
                                      <h6>{{employee.name}}</h6>                                      
                                      <p class="fw-semi-bold">{{employee.totalCalls}} follow-ups - {{employee.conversionRate}}% Conversion Rate</p>
                                    </div>
                                </div>                                  
                                <div class="chart-panel">                                    
                                    <ChartJSBarChart v-if="currentTab==2 && employee.chartData" :chartData="transformBarChartData(employee.chartData)" />
                                </div>
                            </b-card>
                          </div>
                        </div>                           
                    </div>
                </div> 
                <div class="info-section">              
                    <div class="row">                  
                        <div class="col-sm-12">
                          <h6 class="text-success fw-semi-bold">Aging</h6>
                          <div class="inner-tab">
                              <b-tabs v-model="weekToDateSelectedSubTabIndex">
                                  <b-tab title="Outstanding Claims"  active @click="currentSubTab=2.1">
                                      <div class="row">
                                        <div :class="(outstandingClaimsDataWeeklyByEmp && outstandingClaimsDataWeeklyByEmp.length > 0) ? 'col-sm-4 border-right' : 'col-sm-12'">
                                          <b-card  class="background-cover" v-if="((outstandingClaimsDataWeekly && outstandingClaimsDataWeekly.totalCalls > 0) || (outstandingClaimsClaimReceivedDataWeekly && outstandingClaimsClaimReceivedDataWeekly.length > 0))">
                                            <!--
                                            <p class="fs-mini fw-semi-bold">Total calls made: {{outstandingClaimsDataWeekly.totalCalls}} call(s)</p>
                                            -->
                                             <p class="fs-mini fw-semi-bold">Total calls made: <b-button id="occalls-weekly" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >{{outstandingClaimsDataWeekly.totalCalls}} call(s)</span></b-button></p>
                                             <b-popover target="occalls-weekly" triggers="focus" placement="top" v-if="outstandingClaimsTasksDataWeekly && outstandingClaimsTasksDataWeekly.length > 0">
                                                    <template v-slot:title><b>Call(s) made</b></template>              
                                                    <table class="table">
                                                      <thead>
                                                        <tr>                                          
                                                          <th>For Patient</th>                                          
                                                          <th>Called on</th>
                                                          <th><span class="glyphicon glyphicon-user mr-2 mb-1"></span>Team member</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        <tr v-for="(appt, index) in outstandingClaimsTasksDataWeekly" :key="`oc-${ appt.TeamioPatientID}-${ index }`">                                          
                                                          <td>{{formatName(appt.Patient)}}</td>                                          
                                                          <td>{{appt.CreatedAt | dateformat(dateFormatStr)}}</td>
                                                          <td>{{appt.Employee}}</td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </b-popover>
                                            
                                            <p class="fs-mini fw-semi-bold">Claims received from follow-ups: 
                                              <b-button id="ocw" variant="default" class="mb-xs mr-xs btn-xs">
                                                <span v-if="( (outstandingClaimsClaimReceivedDataWeekly && outstandingClaimsClaimReceivedDataWeekly.length===0) || (!outstandingClaimsClaimReceivedDataWeekly) )" class="fs-mini fw-semi-bold" >0 claim(s) </span>
                                                <span v-else-if="outstandingClaimsClaimReceivedDataWeekly && outstandingClaimsClaimReceivedDataWeekly.length > 0" class="fs-mini fw-semi-bold" >{{outstandingClaimsClaimReceivedDataWeekly.length}} claim(s) </span>
                                              </b-button>
                                              {{sumArrValue(outstandingClaimsClaimReceivedDataWeekly, 'ClaimValue') | money}}
                                            </p>
                                            <b-popover target="ocw" triggers="focus" placement="top" v-if="outstandingClaimsClaimReceivedDataWeekly && outstandingClaimsClaimReceivedDataWeekly.length > 0">
                                              <template v-slot:title><b>Claim(s) Received</b></template>              
                                              <table class="table">
                                                <thead>
                                                  <tr>                                          
                                                    <th>Patient</th>                                          
                                                    <th>Claim Received</th>
                                                    <th>Insurance Paid Amt</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  <tr v-for="(appt, index) in outstandingClaimsClaimReceivedDataWeekly" :key="`ocw-${ appt.TeamioPatientID}-${ index }`">                                          
                                                    <td>{{formatName(appt.Patient)}}
                                                     
                                                    </td>                                          
                                                    <td>{{appt.UpdatedAt | dateformat(dateFormatStr)}}</td> 
                                                    <td><span class="text-success fw-semi-bold">{{appt.ClaimValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td>                                                       
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </b-popover>
                                            <div class="chart-panel">
                                              <PieChart :chartdata="outstandingClaimsDataWeekly.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                                            </div>
                                          </b-card>
                                          <b-card class="background-cover" v-else>
                                            <EmptyState :restricted="!$can('view', 'outstanding_claim')" subject="outstanding_claim" />
                                          </b-card>
                                        </div>
                                        <div class="col-sm-8" v-if="outstandingClaimsDataWeeklyByEmp && outstandingClaimsDataWeeklyByEmp.length > 0">
                                        <h5 class="fw-semi-bold">Breakdown by Team member(s)</h5>
                                        <div class="slider-panel slider-panel1 team-member-slider">
                                            <b-card  class="background-cover" v-for="(employee, index) in outstandingClaimsDataWeeklyByEmp" :key="`employee-${index}`">
                                                <div class="person-name">
                                                    <!--<img data-v-5834cfff="" src="/img/a5.84f014f0.jpg" alt="..." class="rounded-circle">-->
                                                    <span class="glyphicon glyphicon-user mr-2"></span>
                                                    <div>
                                                      <h6>{{employee.name}}</h6>                                                      
                                                      <p class="fw-semi-bold">{{employee.totalCalls}} calls - {{employee.totalReceived}} claim(s) received</p>
                                                    </div>
                                                  </div>
                                                  <div class="chart-panel">                                                       
                                                      <ChartJSBarChart v-if="currentSubTab==2.1 && employee.chartData" :chartData="transformBarChartData(employee.chartData)" />
                                                  </div>
                                            </b-card>
                                          </div>                          
                                        </div> 
                                      </div>
                                  </b-tab>  
                                  <b-tab title="Pre-authorizations" @click="currentSubTab=2.2;">
                                      <div class="row">
                                          <div :class="(preAuthOutstandingDataWeeklyByEmp && preAuthOutstandingDataWeeklyByEmp.length > 0) ? 'col-sm-4 border-right' : 'col-sm-12'">
                                              <h5 class="fw-semi-bold">Outstanding PreAuthorizations</h5>
                                              <b-card  class="background-cover" v-if="((preAuthOutstandingDataWeekly && preAuthOutstandingDataWeekly.totalCalls > 0) || (preAuthOutstandingClaimReceivedDataWeekly && preAuthOutstandingClaimReceivedDataWeekly.length > 0))">
                                                  <!--
                                                  <p class="fs-mini fw-semi-bold">Total calls made: {{preAuthOutstandingDataWeekly.totalCalls}} call(s)</p>
                                                  -->
                                                  <p class="fs-mini fw-semi-bold">Total calls made: <b-button id="opcalls-weekly" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >{{preAuthOutstandingDataWeekly.totalCalls}} call(s)</span></b-button></p>
                                                  <b-popover target="opcalls-weekly" triggers="focus" placement="top" v-if="preAuthOutstandingTasksDataWeekly && preAuthOutstandingTasksDataWeekly.length > 0">
                                                      <template v-slot:title><b>Call(s) made</b></template>              
                                                      <table class="table">
                                                        <thead>
                                                          <tr>                                          
                                                            <th>For Patient</th>                                          
                                                            <th>Called on</th>
                                                            <th><span class="glyphicon glyphicon-user mr-2 mb-1"></span>Team member</th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          <tr v-for="(appt, index) in preAuthOutstandingTasksDataWeekly" :key="`po-${ appt.TeamioPatientID}-${ index }`">                                          
                                                            <td>{{formatName(appt.Patient)}}</td>                                          
                                                            <td>{{appt.CreatedAt | dateformat(dateFormatStr)}}</td>
                                                            <td>{{appt.Employee}}</td>
                                                          </tr>
                                                        </tbody>
                                                      </table>
                                                    </b-popover>
                                                  
                                                  <p class="fs-mini fw-semi-bold">Claims received from follow-ups: 
                                                    <b-button id="paw" variant="default" class="mb-xs mr-xs btn-xs">
                                                      <span v-if="( (preAuthOutstandingClaimReceivedDataWeekly && preAuthOutstandingClaimReceivedDataWeekly.length === 0) || (!preAuthOutstandingClaimReceivedDataWeekly) )" class="fs-mini fw-semi-bold" >0 claim(s) </span>
                                                      <span v-else-if="preAuthOutstandingClaimReceivedDataWeekly && preAuthOutstandingClaimReceivedDataWeekly.length > 0" class="fs-mini fw-semi-bold" >{{preAuthOutstandingClaimReceivedDataWeekly.length}} claim(s) </span>
                                                    </b-button>
                                                    {{sumArrValue(preAuthOutstandingClaimReceivedDataWeekly, 'ClaimValue') | money}}
                                                  </p>
                                                  <b-popover target="paw" triggers="focus" placement="top" v-if="preAuthOutstandingClaimReceivedDataWeekly && preAuthOutstandingClaimReceivedDataWeekly.length > 0">
                                                    <template v-slot:title><b>Claim(s) Received</b></template>              
                                                    <table class="table">
                                                      <thead>
                                                        <tr>                                          
                                                          <th>Patient</th>                                          
                                                          <th>Claim Received</th>
                                                          <th>Insurance Estimate</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        <tr v-for="(appt, index) in preAuthOutstandingClaimReceivedDataWeekly" :key="`paw-${ appt.TeamioPatientID}-${ index }`">                                          
                                                          <td>{{formatName(appt.Patient)}}
                                                         
                                                          </td>                                          
                                                          <td>{{appt.UpdatedAt | dateformat(dateFormatStr)}}</td>
                                                          <td><span class="fw-semi-bold text-success">{{appt.ClaimValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td>                                                         
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </b-popover>
                                                  <div class="chart-panel">
                                                    <PieChart v-if="currentSubTab==2.2" :chartdata="preAuthOutstandingDataWeekly.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                                                  </div>
                                              </b-card>
                                              <b-card class="background-cover" v-else>
                                                <EmptyState :restricted="!$can('view', 'outstanding_preauths')" subject="outstanding_preauths" />
                                              </b-card>
                                          </div>
                                          <div class="col-sm-8" v-if="preAuthOutstandingDataWeeklyByEmp && preAuthOutstandingDataWeeklyByEmp.length > 0">
                                            <h5 class="fw-semi-bold">Breakdown by Team member</h5>
                                            <div class="slider-panel slider-panel6 team-member-slider">
                                              <b-card  class="background-cover" v-for="(employee, index) in this.preAuthOutstandingDataWeeklyByEmp" :key="`employee-${index}`">
                                                  <div class="person-name">
                                                      <!--<img data-v-5834cfff="" src="/img/a5.84f014f0.jpg" alt="..." class="rounded-circle">-->
                                                      <span class="glyphicon glyphicon-user mr-2"></span>
                                                      <div>
                                                        <h6>{{employee.name}}</h6>
                                                        <p class="fw-semi-bold">{{employee.totalCalls}} calls - {{employee.totalReceived}} claim(s) received</p>
                                                      </div>
                                                    </div>                                  
                                                    <div class="chart-panel">
                                                      <ChartJSBarChart v-if="currentSubTab==2.2 && employee.chartData" :chartData="transformBarChartData(employee.chartData)" />
                                                    </div>
                                              </b-card>                            
                                            </div>
                                          </div>                            
                                      </div>
                                      <!--
                                      <div class="row mt-4">
                                        <div class="col-sm-4 border-right">
                                          <h5 class="fw-semi-bold">Received PreAuthorizations</h5>                     
                                            <b-card class=" background-cover" v-if="((preAuthReceivedDataWeekly && preAuthReceivedDataWeekly.totalCalls > 0) || (preAuthReceivedScheduledDataWeekly && preAuthReceivedScheduledDataWeekly.length > 0))">
                                                    <p class="fs-mini fw-semi-bold">Total calls made: <b-button id="pacalls-weekly" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >{{preAuthReceivedDataWeekly.totalCalls}} call(s)</span></b-button></p>
                                                    <b-popover target="pacalls-weekly" triggers="focus" placement="top" v-if="preAuthReceivedTasksDataWeekly && preAuthReceivedTasksDataWeekly.length > 0">
                                                      <template v-slot:title><b>Call(s) made</b></template>              
                                                      <table class="table">
                                                        <thead>
                                                          <tr>                                          
                                                            <th>Patient</th>                                          
                                                            <th>Called on</th>
                                                            <th><span class="glyphicon glyphicon-user mr-2 mb-1"></span>Team member</th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          <tr v-for="(appt, index) in preAuthReceivedTasksDataWeekly" :key="`od-${ appt.TeamioPatientID}-${ index }`">                                          
                                                            <td>{{formatName(appt.Patient)}}</td>                                          
                                                            <td>{{appt.CreatedAt | dateformat(dateFormatStr)}}</td>
                                                            <td>{{appt.Employee}}</td>
                                                          </tr>
                                                        </tbody>
                                                      </table>
                                                    </b-popover>
                                                    
                                                    <p class="fs-mini fw-semi-bold">Total scheduled: 
                                                      <b-button id="parw" variant="default" class="mb-xs mr-xs btn-xs">
                                                        <span v-if="( (preAuthReceivedScheduledDataWeekly && preAuthReceivedScheduledDataWeekly.length === 0) || (!preAuthReceivedScheduledDataWeekly) )" class="fs-mini fw-semi-bold" >0 appointment(s)</span>
                                                        <span v-else-if="preAuthReceivedScheduledDataWeekly && preAuthReceivedScheduledDataWeekly.length > 0" class="fs-mini fw-semi-bold" >{{preAuthReceivedScheduledDataWeekly.length}} appointment(s)</span>
                                                      </b-button>
                                                    </p>
                              
                                                    <b-popover target="parw" triggers="focus" placement="top" v-if="preAuthReceivedScheduledDataWeekly && preAuthReceivedScheduledDataWeekly.length > 0">
                                                      <template v-slot:title><b>Appointment(s) Scheduled</b></template>              
                                                      <table class="table">
                                                        <thead>
                                                          <tr>                                          
                                                            <th>Patient</th>                                          
                                                            <th>Appointment Value</th>
                                                            <th>Created on</th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          <tr v-for="(appt, index) in preAuthReceivedScheduledDataWeekly" :key="`parw-${ appt.TeamioPatientID}-${ index }`">                                          
                                                            <td>{{formatName(appt.Patient)}}
                                                           </td>                                          
                                                            <td><span class="text-success fw-semi-bold">{{appt.AppointmentValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td>
                                                            <td>{{appt.UpdatedAt | dateformat(dateFormatStr)}}</td>                                                           
                                                          </tr>
                                                        </tbody>
                                                      </table>
                                                    </b-popover>
                                                                                  
                                              <div class="chart-panel">
                                                  <PieChart v-if="currentSubTab==2.2" :chartdata="preAuthReceivedDataWeekly.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                                              </div>
                                            </b-card>
                                            <b-card  class="background-cover"  v-else>
                                              <div>
                                              <div class="empty-state">
                              <div class="empty-state-icon">
                                <i class="fa fa-bar-chart"></i>
                              </div>
                              <div class="empty-state-title">No Data Available</div>
                              <div class="empty-state-text">Data will appear once activity is recorded</div>
                            </div>
                                              </div>
                                            </b-card>
                                        </div>                  
                                        <div class="col-sm-8" v-if="preAuthReceivedDataWeeklyByEmp && preAuthReceivedDataWeeklyByEmp.length > 0">   
                                          <h5 class="fw-semi-bold">Breakdown by Team member(s)</h5>                                       
                                          <div class="slider-panel slider-panel1 team-member-slider">
                                            <b-card  class=" background-cover" v-for="(employee, index) in this.preAuthReceivedDataWeeklyByEmp" :key="`employee-${index}`">
                                                <div class="person-name">
                                                    <span class="glyphicon glyphicon-user mr-2"></span>
                                                    <div>
                                                      <h6>{{employee.name}}</h6>
                                                      <p class="fw-semi-bold">{{employee.totalCalls}} Call(s) - Conversion rate {{employee.conversionRate}}%</p>
                                                    </div>
                                                  </div>                                  
                                                  <div class="chart-panel">
                                                      <InsightMSBarChart v-if="currentSubTab==2.2" :chartData="employee.chartData"></InsightMSBarChart>                                                                                        
                                                  </div>
                                            </b-card>  
                                                                             
                                          </div>
                                        </div>                            
                                    </div>
                                  -->
                                  </b-tab> 
                                  <b-tab title="Patient Balances" @click="currentSubTab=2.3">
                                      <div class="row">
                                          <div :class="(patientBalancesDataWeeklyByEmp && patientBalancesDataWeeklyByEmp.length > 0) ? 'col-sm-4 border-right' : 'col-sm-12'">
                                              <h5 class="fw-semi-bold">Collection Follow-ups</h5>

                                              <b-card  class=" background-cover" v-if="((patientBalancesDataWeekly && patientBalancesDataWeekly.totalCalls > 0)  )">
 
                                              <!--
                                              <b-card  class=" background-cover" v-if="((patientBalancesDataWeekly && patientBalancesDataWeekly.totalCalls > 0) )">
                                              -->   
                                                  <p class="fs-mini fw-semi-bold">Patient Collection follow-ups made: <b-button id="pbcalls-weekly" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >{{patientBalancesDataWeekly.totalCalls}} follow-up(s)</span></b-button></p>
                                                  <b-popover target="pbcalls-weekly" triggers="focus" placement="top" v-if="patientBalancesTasksDataWeekly && patientBalancesTasksDataWeekly.length > 0">
                                                    <template v-slot:title><b>Follow-up(s) made</b></template>              
                                                    <table class="table">
                                                      <thead>
                                                        <tr>                                          
                                                          <th>Patient</th>                                          
                                                          <th>Followed-up on</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        <tr v-for="(appt, index) in patientBalancesTasksDataWeekly" :key="`od-${ appt.TeamioPatientID}-${ index }`">                                          
                                                          <td>{{formatName(appt.Patient)}}</td>                                          
                                                          <td>{{appt.CreatedAt | dateformat(dateFormatStr)}}</td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </b-popover>
                                             
                                                <!--
                                                  <p class="fs-mini fw-semi-bold" v-if="patientBalancesPaidSumWeekly">Collected from Follow-up(s): 
                                                    <b-button id="pbcollectweekly" variant="default" class="mb-xs mr-xs btn-xs">
                                                      <span class="fs-mini fw-semi-bold" >${{patientBalancesPaidSumWeekly | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
                                                    </b-button>
                                                  </p>

                                                  <b-popover target="pbcollectweekly" triggers="focus" placement="top" v-if="patientBalancesPaidWeekly && patientBalancesPaidWeekly.length > 0">
                                                    <template v-slot:title><b>Payment(s) Collected</b></template>              
                                                    <p>
                                                      <span class="fw-semi-bold">Total collected</span>  - is the cumulative amount the patient has paid upto most recept payment date since your first follow-up for the balance on the account.  
                                                    </p>
                                                    <table class="table">
                                                      <thead>
                                                        <tr>                                          
                                                          <th>Patient</th>                                          
                                                          <th>Total Collected</th>
                                                          <th>Most recent payment date</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        <tr v-for="(appt, index) in patientBalancesPaidWeekly" :key="`pbcd-${ appt.TeamioPatientID}-${ index }`">                                          
                                                          <td>{{formatName(appt.Patient)}}</td>
                                                          <td><span class="fw-semi-bold text-success">{{appt.PatientBalanceAmountPaid | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td>                                               
                                                          <td>{{appt.MostRecentBalancePaidDate | dateformat(dateFormatStr)}}</td>                                                                                                      
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </b-popover>
                                             
                                                -->                             
                                                    <div class="chart-panel">
                                                        <PieChart :chartdata="patientBalancesDataWeekly.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                                                    </div>
                                              </b-card>
                                              <b-card class="background-cover" v-else>
                                                <EmptyState :restricted="!$can('view', 'patient_balances')" subject="patient_balances" />
                                              </b-card>
                                          </div>
                                          <div class="col-sm-8" v-if="patientBalancesDataWeeklyByEmp && patientBalancesDataWeeklyByEmp.length > 0"> 
                                            <h5 class="fw-semi-bold">Breakdown by Team member(s)</h5>                                         
                                            <div class="slider-panel">
                                            <b-card  class=" background-cover" v-for="(employee, index) in this.patientBalancesDataWeeklyByEmp" :key="`employee-${index}`">
                                                <div class="person-name">
                                                    <!--<img data-v-5834cfff="" src="/img/a5.84f014f0.jpg" alt="..." class="rounded-circle">-->
                                                    <span class="glyphicon glyphicon-user mr-2"></span>
                                                    <div>
                                                      <h6>{{employee.name}}</h6>
                                                      <p class="fw-semi-bold">{{employee.totalCalls}} Follow-up(s)</p>
                                                    </div>
                                                  </div>                                  
                                                  <div class="chart-panel">                                                    
                                                    <ChartJSBarChart v-if="currentSubTab==2.3 && employee.chartData" :chartData="transformBarChartData(employee.chartData)" />                                                                                                                                           
                                                  </div>
                                            </b-card>                                          
                                        </div>
                                          </div>                            
                                      </div>  
                                  </b-tab>  
                              </b-tabs>
                          </div>                                                
                        </div>                           
                    </div>
                </div> 
                <div class="info-section">
                    <div class="row">
                        <div :class="(brokenAppointmentDataWeeklyByEmp && brokenAppointmentDataWeeklyByEmp.length > 0) ? 'col-sm-4 border-right' : 'col-sm-12'">
                          <h5 class="fw-semi-bold">Broken Appointment Follow-ups</h5>
                          <b-card  class=" background-cover" v-if="((brokenAppointmentDataWeekly && brokenAppointmentDataWeekly.totalCalls > 0) || (brokenAppointmentScheduledDataWeekly && brokenAppointmentScheduledDataWeekly.length > 0) )">
                               <!--
                               <p class="fs-mini fw-semi-bold">Total calls made: {{brokenAppointmentDataWeekly.totalCalls}} call(s)</p>
                               -->
                               <p class="fs-mini fw-semi-bold">Total follow-ups made: <b-button id="bacalls-weekly" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >{{brokenAppointmentDataWeekly.totalCalls}} follow-up(s)</span></b-button></p>
                               <b-popover target="bacalls-weekly" triggers="focus" placement="top" v-if="brokenAppointmentTasksDataWeekly && brokenAppointmentTasksDataWeekly.length > 0">
                                  <template v-slot:title><b>Follow-up(s) made</b></template>              
                                  <table class="table">
                                    <thead>
                                      <tr>                                          
                                        <th>Patient</th>                                          
                                        <th>Followed-up on</th>
                                        <th><span class="glyphicon glyphicon-user mr-2 mb-1"></span>Team member</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(appt, index) in brokenAppointmentTasksDataWeekly" :key="`od-${ appt.TeamioPatientID}-${ index }`">                                          
                                        <td>{{formatName(appt.Patient)}}</td>                                          
                                        <td>{{appt.CreatedAt | dateformat(dateFormatStr)}}</td>
                                        <td>{{appt.Employee}}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </b-popover>
                               
                               <p class="fs-mini fw-semi-bold">Total scheduled: 
                                 <b-button id="bascheduled-weekly" variant="default" class="mb-xs mr-xs btn-xs">
                                   <span v-if="( (brokenAppointmentScheduledDataWeekly && brokenAppointmentScheduledDataWeekly.length === 0) || (!brokenAppointmentScheduledDataWeekly) )" class="fs-mini fw-semi-bold" >0 appointment(s)</span>
                                   <span v-else-if="brokenAppointmentScheduledDataWeekly && brokenAppointmentScheduledDataWeekly.length > 0" class="fs-mini fw-semi-bold" >{{brokenAppointmentScheduledDataWeekly.length}} appointment(s)</span>
                                   </b-button>
                                   {{sumArrValue(brokenAppointmentScheduledDataWeekly, 'AppointmentValue') | money}}
                                  </p>
                                <b-popover target="bascheduled-weekly" triggers="focus" placement="top" v-if="brokenAppointmentScheduledDataWeekly && brokenAppointmentScheduledDataWeekly.length > 0">
                                  <template v-slot:title><b>Appointment(s) Scheduled</b></template>              
                                  <table class="table">
                                  <thead>
                                    <tr>                                          
                                      <th>Patient</th>                                          
                                      <th>Appointment Value</th>
                                      <th>Created on</th>

                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(appt, index) in brokenAppointmentScheduledDataWeekly" :key="`baweekly-${appt.TeamioPatientID}-${ index }`">                                          
                                      <td>{{formatName(appt.Patient)}}
                                      </td>                                          
                                      <td><span class="text-success fw-semi-bold">{{appt.AppointmentValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td>
                                      <td>{{appt.UpdatedAt | dateformat(dateFormatStr)}}</td>                                                          
                                                         
                                    </tr>
                                  </tbody>
                                </table>
                              </b-popover>
                               <div class="chart-panel">
                                    <PieChart :chartdata="brokenAppointmentDataWeekly.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                              </div>
                          </b-card>
                          <b-card class="background-cover" v-else>
                            <EmptyState :restricted="!$can('view', 'broken_appointment')" subject="broken_appointment" />
                          </b-card>
                        </div>
                        <div class="col-sm-8" v-if="brokenAppointmentDataWeeklyByEmp && brokenAppointmentDataWeeklyByEmp.length > 0 ">
                            <h5 class="fw-semi-bold">Breakdown by Team member(s)</h5>
                            <div class="slider-panel slider-panel5 team-member-slider">
                                <b-card  class="background-cover" v-for="(employee, index) in this.brokenAppointmentDataWeeklyByEmp" :key="`employee-${index}`">
                                    <div class="person-name">
                                        <!--<img data-v-5834cfff="" src="/img/a5.84f014f0.jpg" alt="..." class="rounded-circle">-->
                                        <span class="glyphicon glyphicon-user mr-2"></span>
                                        <div>
                                          <h6>{{employee.name}}</h6>                                          
                                          <p class="fw-semi-bold">{{employee.totalCalls}} follow-ups - {{employee.conversionRate}}% Conversion Rate</p>
                                        </div>
                                      </div>                                  
                                      <div class="chart-panel">                                          
                                          <ChartJSBarChart v-if="currentTab==2" :chartData="transformBarChartData(employee.chartData)" />                                                                           
                                      </div>
                                </b-card>
                            </div>                          
                          </div>                                   
                    </div>
                </div>  
                <!--
                <div class="info-section">              
                    <div class="row">                  
                        <div class="col-sm-4">
                          <h6 class="text-success fw-semi-bold">Insurance Verifications <sup class="ml-1 headerLabel text-danger">Coming soon!</sup></h6>
                          <b-card  class=" background-cover">
                              <div class="person-name">
                                  <div>
                                    <h6>3 Verified</h6>
                                  </div>
                                </div>                                  
                                <div class="chart-panel">
                                    <InsightMSBarChart v-if="currentTab==2" :chartData="getWeekToDateBarChartData3"></InsightMSBarChart>                                    
                                </div>
                          </b-card>
                        </div>                           
                    </div>
                </div>
                -->
            </b-tab>
            <!-- SECOND TAB END -->
            <!-- THIRD TAB START -->
            <b-tab title="Month-to-Date" @click="changeTab(3)">
                <div class="info-section">
                    <div class="row">
                        <div :class="(overdueRecallDataMonthlyByEmp && overdueRecallDataMonthlyByEmp.length > 0) ? 'col-sm-4 border-right' : 'col-sm-12'">
                          <h5 class="fw-semi-bold">Overdue Recall</h5>
                          <b-card  class=" background-cover" v-if="((overdueRecallDataMonthly && overdueRecallDataMonthly.totalCalls > 0 && allSettings) || (overdueRecallScheduledDataMonthly && overdueRecallScheduledDataMonthly.length > 0 && allSettings ))">
                              <!--
                              <p class="fs-mini fw-semi-bold">Total calls made: {{overdueRecallDataMonthly.totalCalls}} call(s)</p>
                              -->
                              <p class="fs-mini fw-semi-bold">Total follow-ups made: <b-button id="odcalls-monthly" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >{{overdueRecallDataMonthly.totalCalls}} follow-up(s)</span></b-button></p>
                              
                              <b-popover target="odcalls-monthly" triggers="focus" placement="top" v-if="overdueRecallTasksDataMonthly && overdueRecallTasksDataMonthly.length > 0">
                                <template v-slot:title><b>Follow-up(s) made</b></template>              
                                <table class="table">
                                  <thead>
                                    <tr>                                          
                                      <th>Patient</th>                                          
                                      <th>Followed-up on</th>
                                      <th><span class="glyphicon glyphicon-user mr-2 mb-1"></span>Team member</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(appt, index) in overdueRecallTasksDataMonthly" :key="`odm-${ appt.TeamioPatientID}-${ index }`">                                          
                                      <td>{{formatName(appt.Patient)}}</td>                                          
                                      <td>{{appt.CreatedAt | dateformat(dateFormatStr)}}</td>
                                      <td>{{appt.Employee}}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </b-popover>
                              <p class="fs-mini fw-semi-bold">Total scheduled: 
                                <b-button id="odm" variant="default" class="mb-xs mr-xs btn-xs">
                                  <span v-if="( (overdueRecallScheduledDataMonthly && overdueRecallScheduledDataMonthly.length===0) || (!overdueRecallScheduledDataMonthly) )" class="fs-mini fw-semi-bold" >0 appointment(s)</span>
                                  <span v-else-if="overdueRecallScheduledDataMonthly && overdueRecallScheduledDataMonthly.length > 0" class="fs-mini fw-semi-bold" >{{overdueRecallScheduledDataMonthly.length}} appointment(s)</span>
                                </b-button>
                                {{sumArrValue(overdueRecallScheduledDataMonthly, 'AppointmentValue') | money}}
                              </p>
                              <h6>Monthly Goal: <span class="fw-semi-bold" >{{this.allSettings.OVERDUE_RECALL_MONTHLY_CALLS_GOAL.PropertyValue}} follow-ups</span></h6>
                              <b-popover target="odm" triggers="focus" placement="top" v-if="overdueRecallScheduledDataMonthly && overdueRecallScheduledDataMonthly.length > 0">
                                <template v-slot:title><b>Appointment(s) Scheduled</b></template>              
                                <table class="table">
                                  <thead>
                                    <tr>                                          
                                      <th>Patient</th>                                          
                                      <th>Appointment Value</th>
                                      <th>Created on</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(appt, index) in overdueRecallScheduledDataMonthly" :key="`od-${ appt.TeamioPatientID}-${ index }`">                                          
                                      <td>{{formatName(appt.Patient)}}
                                       
                                      </td>                                          
                                      <td><span class="text-success fw-semi-bold">{{appt.AppointmentValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td>
                                      <td>{{appt.UpdatedAt | dateformat(dateFormatStr)}}</td>                                                        
                                    </tr>
                                  </tbody>
                                </table>
                              </b-popover>
                              
                                <div class="clearfix fs-mini mt">
                                  <span class="pull-right m-0 fw-semi-bold">Monthly Goal: <span class="fw-semi-bold">{{this.allSettings.OVERDUE_RECALL_MONTHLY_CALLS_GOAL.PropertyValue}} follow-ups</span></span>
                                  <span class="fs-mini">{{((overdueRecallDataMonthly.totalCalls / parseInt(allSettings.OVERDUE_RECALL_MONTHLY_CALLS_GOAL.PropertyValue,10)) * 100).toFixed(0)}}% of Monthly Goal Met</span>
                                </div>
                                <b-progress :max="parseInt(allSettings.OVERDUE_RECALL_MONTHLY_CALLS_GOAL.PropertyValue,10)" variant="success" class="bg-gray-lighter progress-xs" :value="overdueRecallDataMonthly.totalCalls"  />

                                <div class="chart-panel">
                                    <PieChart :chartdata="overdueRecallDataMonthly.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                                </div>
                          </b-card>
                          <b-card class="background-cover" v-else>
                            <EmptyState :restricted="!$can('view', 'overdue_recall')" subject="overdue_recall" />
                          </b-card>
                        </div>
                        <div class="col-sm-8" v-if="overdueRecallDataMonthlyByEmp && overdueRecallDataMonthlyByEmp.length > 0 ">
                            <h5 class="fw-semi-bold">Breakdown by Team member(s)</h5>
                            <div class="slider-panel slider-panel7 team-member-slider">
                                <b-card  class="background-cover" v-for="(employee, index) in this.overdueRecallDataMonthlyByEmp" :key="`employee-${index}`">
                                    <div class="person-name">
                                      <!--<img data-v-5834cfff="" src="/img/a5.84f014f0.jpg" alt="..." class="rounded-circle">-->
                                      <span class="glyphicon glyphicon-user mr-2"></span>
                                      <div>
                                        <h6>{{employee.name}}</h6>
                                        <p class="fw-semi-bold">{{employee.totalCalls}} follow-ups - {{employee.conversionRate}}% Conversion Rate</p>
                                      </div>
                                    </div>                                  
                                    <div class="chart-panel">                                        
                                        <ChartJSBarChart v-if="currentTab==3" :chartData="transformBarChartData(employee.chartData)" />                                         
                                    </div>
                                </b-card>
                            </div>                          
                          </div>                                   
                    </div>
                </div>
                <div class="info-section">
                    <div class="row">
                        <div :class="(unscheduledTreatmentDataMonthlyByEmp && unscheduledTreatmentDataMonthlyByEmp.length > 0) ? 'col-sm-4 border-right' : 'col-sm-12'">
                            <h5 class="fw-semi-bold">Unscheduled Treatment</h5>
                            <b-card  class=" background-cover" v-if="((unscheduledTreatmentDataMonthly && unscheduledTreatmentDataMonthly.totalCalls > 0 && allSettings) || (unscheduledTreatmentScheduledDataMonthly && unscheduledTreatmentScheduledDataMonthly.length > 0 && allSettings ))">
                                <!--
                                <p class="fs-mini fw-semi-bold">Total calls made: {{unscheduledTreatmentDataMonthly.totalCalls}} call(s)</p>
                                -->
                                <p class="fs-mini fw-semi-bold">Total follow-ups made: <b-button id="utcalls-monthly" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >{{unscheduledTreatmentDataMonthly.totalCalls}} follow-up(s)</span></b-button></p>
                                <b-popover target="utcalls-monthly" triggers="focus" placement="top" v-if="unscheduledTreatmentTasksDataMonthly && unscheduledTreatmentTasksDataMonthly.length > 0">
                                <template v-slot:title><b>follow-up(s) made</b></template> 
                                  <table class="table">
                                    <thead>
                                      <tr>                                          
                                        <th>Patient</th>                                          
                                        <th>Followed-up on</th>
                                        <th><span class="glyphicon glyphicon-user mr-2 mb-1"></span>Team member</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(appt, index) in unscheduledTreatmentTasksDataMonthly" :key="`od-${ appt.TeamioPatientID}-${ index }`">                                          
                                        <td>{{formatName(appt.Patient)}}</td>                                          
                                        <td>{{appt.CreatedAt | dateformat(dateFormatStr)}}</td>
                                        <td>{{appt.Employee}}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                              </b-popover>

                                <p class="fs-mini fw-semi-bold">Total scheduled: 
                                  <b-button id="utm" variant="default" class="mb-xs mr-xs btn-xs">
                                    <span v-if="( (unscheduledTreatmentScheduledDataMonthly && unscheduledTreatmentScheduledDataMonthly.length===0) || (!unscheduledTreatmentScheduledDataMonthly) )" class="fs-mini fw-semi-bold" >0 appointment(s)</span>
                                    <span v-else-if="unscheduledTreatmentScheduledDataMonthly && unscheduledTreatmentScheduledDataMonthly.length > 0" class="fs-mini fw-semi-bold" >{{unscheduledTreatmentScheduledDataMonthly.length}} appointment(s)</span>
                                  </b-button>
                                  {{sumArrValue(unscheduledTreatmentScheduledDataMonthly, 'AppointmentValue') | money}}
                                </p>
                                <b-popover target="utm" triggers="focus" placement="top" v-if="unscheduledTreatmentScheduledDataMonthly && unscheduledTreatmentScheduledDataMonthly.length > 0">
                                  <template v-slot:title><b>Appointment(s) Scheduled</b></template>              
                                  <table class="table">
                                    <thead>
                                      <tr>                                          
                                        <th>Patient</th>                                          
                                        <th>Appointment Value</th>
                                        <th>Created on</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(appt, index) in unscheduledTreatmentScheduledDataMonthly" :key="`utm-${ appt.TeamioPatientID}-${ index }`">                                          
                                        <td>{{formatName(appt.Patient)}}
                                         
                                        </td>                                          
                                        <td><span class="text-success fw-semi-bold">{{appt.AppointmentValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td>
                                        <td>{{appt.UpdatedAt | dateformat(dateFormatStr)}}</td>                                                        
                                      </tr>
                                    </tbody>
                                  </table>
                                </b-popover>
                                <div class="clearfix fs-mini mt">
                                  <span class="pull-right m-0 fw-semi-bold">Monthly Goal: <span class="fw-semi-bold">{{this.allSettings.UNSCHEDULED_TREATMENT_MONTHLY_CALLS_GOAL.PropertyValue}} calls</span></span>
                                  <span class="fs-mini">{{((unscheduledTreatmentDataMonthly.totalCalls / parseInt(allSettings.UNSCHEDULED_TREATMENT_MONTHLY_CALLS_GOAL.PropertyValue,10)) * 100).toFixed(0)}}% of Monthly Goal Met</span>
                                </div>
                                <b-progress :max="parseInt(allSettings.UNSCHEDULED_TREATMENT_MONTHLY_CALLS_GOAL.PropertyValue,10)" variant="success" class="bg-gray-lighter progress-xs" :value="unscheduledTreatmentDataMonthly.totalCalls"  />

                                  <div class="chart-panel">
                                      <PieChart :chartdata="unscheduledTreatmentDataMonthly.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                                  </div>
                            </b-card>
                            <b-card class="background-cover" v-else>
                              <EmptyState :restricted="!$can('view', 'unscheduled_treatment')" subject="unscheduled_treatment" />
                            </b-card>
                          </div>
                        <div class="col-sm-8" v-if="unscheduledTreatmentDataMonthlyByEmp && unscheduledTreatmentDataMonthlyByEmp.length > 0">
                          <h5 class="fw-semi-bold">Breakdown by Team member(s)</h5>
                          <div class="slider-panel">
                            <b-card  class=" background-cover" v-for="(employee, index) in this.unscheduledTreatmentDataMonthlyByEmp" :key="`employee-${index}`">
                                <div class="person-name">
                                    <!--<img data-v-5834cfff="" src="/img/a5.84f014f0.jpg" alt="..." class="rounded-circle">-->
                                    <span class="glyphicon glyphicon-user mr-2"></span>
                                    <div>
                                      <h6>{{employee.name}}</h6>
                                      <p class="fw-semi-bold">{{employee.totalCalls}} Follow-up(s) - Conversion Rate {{employee.conversionRate}}%</p>
                                    </div>
                                  </div>                                  
                                  <div class="chart-panel">                                      
                                      <ChartJSBarChart v-if="currentTab==3" :chartData="transformBarChartData(employee.chartData)" />                                 
                                  </div>
                            </b-card>
                        </div>
                        </div>
                    </div>
                </div> 
                <div class="info-section">              
                    <div class="row">                  
                        <div class="col-sm-12">
                          <h6 class="text-success fw-semi-bold">Aging</h6>
                          <div class="inner-tab">
                              <b-tabs v-model="monthToDateSelectedSubTabIndex">
                                  <b-tab title="Outstanding Claims" active @click="currentSubTab=3.1">
                                      <div class="row">
                                          <div :class="(outstandingClaimsDataMonthlyByEmp && outstandingClaimsDataMonthlyByEmp.length > 0) ? 'col-sm-4 border-right' : 'col-sm-12'">
                                              <b-card  class=" background-cover" v-if="((outstandingClaimsDataMonthly && outstandingClaimsDataMonthly.totalCalls > 0) || (outstandingClaimsClaimReceivedDataMonthly && outstandingClaimsClaimReceivedDataMonthly.length > 0))">
                                                  <!--
                                                  <p class="fs-mini fw-semi-bold">Total calls made: {{outstandingClaimsDataMonthly.totalCalls}} call(s)</p>
                                                  -->
                                                  <p class="fs-mini fw-semi-bold">Total calls made: <b-button id="occalls-monthly" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >{{outstandingClaimsDataMonthly.totalCalls}} call(s)</span></b-button></p>
                                                  <b-popover target="occalls-monthly" triggers="focus" placement="top" v-if="outstandingClaimsTasksDataMonthly && outstandingClaimsTasksDataMonthly.length > 0">
                                                    <template v-slot:title><b>Call(s) made</b></template>              
                                                    <table class="table">
                                                      <thead>
                                                        <tr>                                          
                                                          <th>For Patient</th>                                          
                                                          <th>Called on</th>
                                                          <th><span class="glyphicon glyphicon-user mr-2 mb-1"></span>Team member</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        <tr v-for="(appt, index) in outstandingClaimsTasksDataMonthly" :key="`oc-${ appt.TeamioPatientID}-${ index }`">                                          
                                                          <td>{{formatName(appt.Patient)}}</td>                                          
                                                          <td>{{appt.CreatedAt | dateformat(dateFormatStr)}}</td>
                                                          <td>{{appt.Employee}}</td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </b-popover>

                                                  <p class="fs-mini fw-semi-bold">Claims received from follow-ups: 
                                                    <b-button id="ocm" variant="default" class="mb-xs mr-xs btn-xs">
                                                      <span v-if="( (outstandingClaimsClaimReceivedDataMonthly && outstandingClaimsClaimReceivedDataMonthly.length===0) || (!outstandingClaimsClaimReceivedDataMonthly) )" class="fs-mini fw-semi-bold" >0 claim(s) </span>
                                                      <span v-else-if="outstandingClaimsClaimReceivedDataMonthly && outstandingClaimsClaimReceivedDataMonthly.length > 0" class="fs-mini fw-semi-bold" >{{outstandingClaimsClaimReceivedDataMonthly.length}} claim(s) </span>
                                                    </b-button>
                                                    {{sumArrValue(outstandingClaimsClaimReceivedDataMonthly, 'ClaimValue') | money}}
                                                  </p>
                                                  <b-popover target="ocm" triggers="focus" placement="top" v-if="outstandingClaimsClaimReceivedDataMonthly && outstandingClaimsClaimReceivedDataMonthly.length > 0">
                                                    <template v-slot:title><b>Claim(s) Received</b></template>              
                                                    <table class="table">
                                                      <thead>
                                                        <tr>                                          
                                                          <th>Patient</th>                                          
                                                          <th>Claim Received</th>
                                                          <th>Insurance Paid Amt</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        <tr v-for="(appt, index) in outstandingClaimsClaimReceivedDataMonthly" :key="`ocm-${ appt.TeamioPatientID}-${ index }`">                                          
                                                          <td>{{formatName(appt.Patient)}}
                                                            
                                                          </td>                                          
                                                          <td>{{appt.UpdatedAt | dateformat(dateFormatStr)}}</td>
                                                          <td><span class="text-success fw-semi-bold">{{appt.ClaimValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td>                                                         
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </b-popover>                                            
                                                  <div class="chart-panel">
                                                      <PieChart v-if="currentSubTab==3.1" :chartdata="outstandingClaimsDataMonthly.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                                                  </div>
                                              </b-card>
                                              <b-card class="background-cover" v-else>
                                                <EmptyState :restricted="!$can('view', 'outstanding_claim')" subject="outstanding_claim" />
                                              </b-card>
                                            </div>
                                          <div class="col-sm-8" v-if="outstandingClaimsDataMonthlyByEmp && outstandingClaimsDataMonthlyByEmp.length > 0">
                                            <h5 class="fw-semi-bold">Breakdown by Team member(s)</h5>
                                            <div class="slider-panel slider-panel8 team-member-slider">                          
                                            <b-card  class="background-cover" v-for="(employee, index) in this.outstandingClaimsDataMonthlyByEmp" :key="`employee-${index}`">
                                                <div class="person-name">
                                                    <!--<img data-v-5834cfff="" src="/img/a5.84f014f0.jpg" alt="..." class="rounded-circle">-->
                                                    <span class="glyphicon glyphicon-user mr-2"></span>
                                                    <div>
                                                      <h6>{{employee.name}}</h6>
                                                      <p class="fw-semi-bold">{{employee.totalCalls}} calls - {{employee.totalReceived}} claim(s) received</p>
                                                    </div>
                                                  </div>                                  
                                                  <div class="chart-panel">                                                      
                                                      <ChartJSBarChart v-if="currentSubTab==3.1" :chartData="transformBarChartData(employee.chartData)" />
                                                  </div>
                                            </b-card>
                                          </div>
                                          </div>
                                      </div>
                                  </b-tab>  
                                  <b-tab title="Pre-authorizations" @click="currentSubTab=3.2">
                                      <div class="row">
                                          <div :class="(preAuthOutstandingDataMonthlyByEmp && preAuthOutstandingDataMonthlyByEmp.length > 0) ? 'col-sm-4 border-right' : 'col-sm-12'">
                                              <h5 class="fw-semi-bold">Outstanding Pre-Authorizations</h5>
                                              <b-card  class=" background-cover" v-if="((preAuthOutstandingDataMonthly && preAuthOutstandingDataMonthly.totalCalls > 0) || (preAuthOutstandingClaimReceivedDataMonthly && preAuthOutstandingClaimReceivedDataMonthly.length > 0))">
                                                  <!--
                                                  <p class="fs-mini fw-semi-bold">Total calls made: {{preAuthOutstandingDataMonthly.totalCalls}} call(s)</p>
                                                  -->
                                                  <p class="fs-mini fw-semi-bold">Total calls made: <b-button id="opcalls-monthly" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >{{preAuthOutstandingDataMonthly.totalCalls}} call(s)</span></b-button></p>
                                                  <b-popover target="opcalls-monthly" triggers="focus" placement="top" v-if="preAuthOutstandingTasksDataMonthly && preAuthOutstandingTasksDataMonthly.length > 0">
                                                      <template v-slot:title><b>Call(s) made</b></template>              
                                                      <table class="table">
                                                        <thead>
                                                          <tr>                                          
                                                            <th>For Patient</th>                                          
                                                            <th>Called on</th>
                                                            <th><span class="glyphicon glyphicon-user mr-2 mb-1"></span>Team member</th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          <tr v-for="(appt, index) in preAuthOutstandingTasksDataMonthly" :key="`po-${ appt.TeamioPatientID}-${ index }`">                                          
                                                            <td>{{formatName(appt.Patient)}}</td>                                          
                                                            <td>{{appt.CreatedAt | dateformat(dateFormatStr)}}</td>
                                                            <td>{{appt.Employee}}</td>
                                                          </tr>
                                                        </tbody>
                                                      </table>
                                                    </b-popover>
                                                  <p class="fs-mini fw-semi-bold">Claims received from follow-ups: 
                                                    <b-button id="paom" variant="light" class="mb-xs mr-xs btn-xs">
                                                      <span v-if="( (preAuthOutstandingClaimReceivedDataMonthly && preAuthOutstandingClaimReceivedDataMonthly.length === 0) || (!preAuthOutstandingClaimReceivedDataMonthly) )" class="fs-mini fw-semi-bold" >0 claim(s) </span>
                                                      <span v-else-if="preAuthOutstandingClaimReceivedDataMonthly && preAuthOutstandingClaimReceivedDataMonthly.length > 0" class="fs-mini fw-semi-bold" >{{preAuthOutstandingClaimReceivedDataMonthly.length}} claim(s) </span>
                                                    </b-button>
                                                    {{sumArrValue(preAuthOutstandingClaimReceivedDataMonthly, 'ClaimValue') | money}}
                                                  </p>
                                                  <b-popover target="paom" triggers="focus" placement="top" v-if="preAuthOutstandingClaimReceivedDataMonthly && preAuthOutstandingClaimReceivedDataMonthly.length > 0">
                                                    <template v-slot:title><b>Claim(s) Received</b></template>              
                                                    <table class="table">
                                                      <thead>
                                                        <tr>                                          
                                                          <th>Patient</th>                                          
                                                          <th>Claim Received</th>
                                                          <th>Insurance Estimate</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        <tr v-for="(appt, index) in preAuthOutstandingClaimReceivedDataMonthly" :key="`paom-${ appt.TeamioPatientID}-${ index }`">                                          
                                                          <td>{{formatName(appt.Patient)}}
                                                            
                                                          </td>                                          
                                                          <td>{{appt.UpdatedAt | dateformat(dateFormatStr)}}</td>
                                                          <td><span class="fw-semi-bold text-success">{{appt.ClaimValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td>                                                         
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </b-popover>
                                                  <div class="chart-panel">
                                                      <PieChart :chartdata="preAuthOutstandingDataMonthly.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                                                  </div>
                                              </b-card>
                                              <b-card class="background-cover" v-else>
                                                <EmptyState :restricted="!$can('view', 'outstanding_preauths')" subject="outstanding_preauths" />
                                              </b-card>
                                          </div>
                                          <div class="col-sm-8" v-if="preAuthOutstandingDataMonthlyByEmp && preAuthOutstandingDataMonthlyByEmp.length > 0">
                                            <h5 class="fw-semi-bold">Breakdown by Team member(s)</h5>
                                            <div class="slider-panel slider-panel10 team-member-slider">
                                            <b-card  class="background-cover" v-for="(employee, index) in this.preAuthOutstandingDataMonthlyByEmp" :key="`employee-${index}`">
                                                <div class="person-name">
                                                    <span class="glyphicon glyphicon-user mr-2"></span>
                                                    <div>
                                                      <h6>{{employee.name}}</h6>                                                      
                                                      <p class="fw-semi-bold">{{employee.totalCalls}} calls - {{employee.totalReceived}} claim(s) received</p>
                                                    </div>
                                                  </div>                                  
                                                  <div class="chart-panel">                                                      
                                                      <ChartJSBarChart v-if="currentSubTab==3.2" :chartData="transformBarChartData(employee.chartData)" />
                                                  </div>
                                            </b-card>
                                        </div>
                                          </div>                            
                                      </div>
                                      <!--
                                      <div class="row mt-4">
                                          <div class="col-sm-4 border-right">
                                            <h5 class="fw-semi-bold">Received PreAuthorizations</h5>                     
                                            <b-card  class=" background-cover" v-if="((preAuthReceivedDataMonthly && preAuthReceivedDataMonthly.totalCalls) || (preAuthReceivedScheduledDataMonthly && preAuthReceivedScheduledDataMonthly.length > 0))">
                                                 <p class="fs-mini fw-semi-bold">Total calls made: <b-button id="pacalls-monthly" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >{{preAuthReceivedDataMonthly.totalCalls}} call(s)</span></b-button></p>
                                                  <b-popover target="pacalls-monthly" triggers="focus" placement="top" v-if="preAuthReceivedTasksDataMonthly && preAuthReceivedTasksDataMonthly.length > 0">
                                                      <template v-slot:title><b>Call(s) made</b></template>              
                                                      <table class="table">
                                                        <thead>
                                                          <tr>                                          
                                                            <th>Patient</th>                                          
                                                            <th>Called on</th>
                                                            <th><span class="glyphicon glyphicon-user mr-2 mb-1"></span>Team member</th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          <tr v-for="(appt, index) in preAuthReceivedTasksDataMonthly" :key="`od-${ appt.TeamioPatientID}-${ index }`">                                          
                                                            <td>{{formatName(appt.Patient)}}</td>                                          
                                                            <td>{{appt.CreatedAt | dateformat(dateFormatStr)}}</td>
                                                            <td>{{appt.Employee}}</td>
                                                          </tr>
                                                        </tbody>
                                                      </table>
                                                    </b-popover>
                                                  <p class="fs-mini fw-semi-bold">Total scheduled: 
                                                    <b-button id="pardm" variant="light" class="mb-xs mr-xs btn-xs">
                                                      <span v-if="( (preAuthReceivedScheduledDataMonthly && preAuthReceivedScheduledDataMonthly.length === 0) || (!preAuthReceivedScheduledDataMonthly) )" class="fs-mini fw-semi-bold" >0 appointment(s)</span>
                                                      <span v-else-if="preAuthReceivedScheduledDataMonthly && preAuthReceivedScheduledDataMonthly.length > 0" class="fs-mini fw-semi-bold" >{{preAuthReceivedScheduledDataMonthly.length}} appointment(s)</span>
                                                    </b-button>
                                                  </p>
                                                  <b-popover target="pardm" triggers="focus" placement="top" v-if="preAuthReceivedScheduledDataMonthly && preAuthReceivedScheduledDataMonthly.length > 0">
                                                    <template v-slot:title><b>Appointment(s) Scheduled</b></template>              
                                                    <table class="table">
                                                      <thead>
                                                        <tr>                                          
                                                          <th>Patient</th>                                          
                                                          <th>Appointment Value</th>
                                                          <th>Created on</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        <tr v-for="(appt, index) in preAuthReceivedScheduledDataMonthly" :key="`pardm-${ appt.TeamioPatientID}-${ index }`">                                          
                                                          <td>{{formatName(appt.Patient)}}</td>                                          
                                                          <td><span class="text-success fw-semi-bold">{{appt.AppointmentValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td>
                                                          <td>{{appt.UpdatedAt | dateformat(dateFormatStr)}}</td>                                                          
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </b-popover>
                                                <div class="chart-panel">
                                                    <PieChart :chartdata="preAuthReceivedDataMonthly.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>                                                     
                                                </div>
                                            </b-card>
                                            <b-card  class="background-cover"  v-else>
                                              <div>
                                              <div class="empty-state">
                              <div class="empty-state-icon">
                                <i class="fa fa-bar-chart"></i>
                              </div>
                              <div class="empty-state-title">No Data Available</div>
                              <div class="empty-state-text">Data will appear once activity is recorded</div>
                            </div>
                                              </div>
                                            </b-card>
                                        </div>                  
                                        <div class="col-sm-8" v-if="preAuthReceivedDataMonthlyByEmp && preAuthReceivedDataMonthlyByEmp.length > 0">
                                          <h5 class="text-success fw-semi-bold">Breakdown by Team member(s)</h5>                                       
                                          <div class="slider-panel slider-panel1 team-member-slider">
                                            <b-card  class=" background-cover" v-for="(employee, index) in this.preAuthReceivedDataMonthlyByEmp" :key="`employee-${index}`">
                                              <div class="person-name">
                                                  <span class="glyphicon glyphicon-user mr-2"></span>
                                                  <div>
                                                    <h6>{{employee.name}}</h6>
                                                    <p class="fw-semi-bold">{{employee.totalCalls}} calls - Conversion rate {{employee.conversionRate}}%</p>
                                                  </div>
                                                </div>                                  
                                                <div class="chart-panel">
                                                    <InsightMSBarChart v-if="currentSubTab==3.2" :chartData="employee.chartData"></InsightMSBarChart>                                                    
                                                </div>
                                            </b-card>                                          
                                      </div>
                                        </div>                            
                                    </div>
                                    -->
                                  </b-tab> 
                                  <b-tab title="Patient Balances" @click="currentSubTab=3.3">
                                      <div class="row">
                                          <div :class="(patientBalancesDataMonthlyByEmp && patientBalancesDataMonthlyByEmp.length > 0) ? 'col-sm-4 border-right' : 'col-sm-12'">
                                              <h5 class="fw-semi-bold">Collection Follow-ups</h5>

                                              <b-card  class=" background-cover" v-if="((patientBalancesDataMonthly && patientBalancesDataMonthly.totalCalls > 0) )">

                                                <!--
                                               <b-card  class=" background-cover" v-if="((patientBalancesDataMonthly && patientBalancesDataMonthly.totalCalls > 0) )">
                                               -->    
                                                    <p class="fs-mini fw-semi-bold">Patient Collection follow-ups made: <b-button id="pbcalls-monthly" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >{{patientBalancesDataMonthly.totalCalls}} call(s)</span></b-button></p>
                                                    <b-popover target="pbcalls-monthly" triggers="focus" placement="top" v-if="patientBalancesTasksDataMonthly && patientBalancesTasksDataMonthly.length > 0">
                                                      <template v-slot:title><b>Follow-up(s) made</b></template>              
                                                      <table class="table">
                                                        <thead>
                                                          <tr>                                          
                                                            <th>Patient</th>                                          
                                                            <th>Followed-up on</th>
                                                            <th><span class="glyphicon glyphicon-user mr-2 mb-1"></span>Team member</th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          <tr v-for="(appt, index) in patientBalancesTasksDataMonthly" :key="`od-${ appt.TeamioPatientID}-${ index }`">                                          
                                                            <td>{{formatName(appt.Patient)}}</td>                                          
                                                            <td>{{appt.CreatedAt | dateformat(dateFormatStr)}}</td>
                                                            <td>{{appt.Employee}}</td>
                                                          </tr>
                                                        </tbody>
                                                      </table>
                                                  </b-popover>
                                                <!--
                                                  <p class="fs-mini fw-semi-bold" v-if="patientBalancesPaidSumMonthly">Collected from Follow-up(s): <b-button id="pbcollectmonthly" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >${{patientBalancesPaidSumMonthly}}</span></b-button></p>

                                                   <b-popover target="pbcollectmonthly" triggers="focus" placement="top" v-if="patientBalancesPaidMonthly && patientBalancesPaidMonthly.length > 0">
                                                    <template v-slot:title><b>Payment(s) Collected</b></template>              
                                                    <p>
                                                      <span class="fw-semi-bold">Total collected</span>  - is the cumulative amount the patient has paid upto most recept payment date since your first follow-up for the balance on the account.  
                                                    </p>
                                                    <table class="table">
                                                      <thead>
                                                        <tr>                                          
                                                          <th>Patient</th>                                          
                                                          <th>Total Collected</th>
                                                          <th>Most recent payment date</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        <tr v-for="(appt, index) in patientBalancesPaidMonthly" :key="`pbcd-${ appt.TeamioPatientID}-${ index }`">                                          
                                                          <td>{{formatName(appt.Patient)}}</td>
                                                          <td><span class="fw-semi-bold text-success">{{appt.PatientBalanceAmountPaid | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td>                                               
                                                          <td>{{appt.MostRecentBalancePaidDate | dateformat(dateFormatStr)}}</td>                                                                                                      
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </b-popover>
                                                -->                             
                                                    <div class="chart-panel">
                                                        <PieChart :chartdata="patientBalancesDataMonthly.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                                                    </div>
                                              </b-card>
                                              <b-card class="background-cover" v-else>
                                                <EmptyState :restricted="!$can('view', 'patient_balances')" subject="patient_balances" />
                                              </b-card>
                                          </div>
                                          <div class="col-sm-8" v-if="patientBalancesDataMonthlyByEmp && patientBalancesDataMonthlyByEmp.length > 0">                                          
                                            <h5 class="fw-semi-bold">Breakdown by Team member(s)</h5>
                                            <div class="slider-panel">
                                            <b-card  class=" background-cover" v-for="(employee, index) in this.patientBalancesDataMonthlyByEmp" :key="`employee-${index}`">
                                                <div class="person-name">
                                                    <!--<img data-v-5834cfff="" src="/img/a5.84f014f0.jpg" alt="..." class="rounded-circle">-->
                                                    <span class="glyphicon glyphicon-user mr-2"></span>
                                                    <div>
                                                      <h6>{{employee.name}}</h6>                                                      
                                                      <p class="fw-semi-bold">{{employee.totalCalls}} follow-ups</p>
                                                    </div>
                                                  </div>                                  
                                                  <div class="chart-panel">                                                      
                                                      <ChartJSBarChart v-if="currentSubTab==3.3" :chartData="transformBarChartData(employee.chartData)" />
                                                  </div>
                                            </b-card>                                          
                                        </div>
                                          </div>                            
                                      </div>  
                                  </b-tab>  
                              </b-tabs>
                          </div>                                                
                        </div>                           
                    </div>
                </div> 
                <div class="info-section">
                    <div class="row">
                        <div :class="(brokenAppointmentDataMonthlyByEmp && brokenAppointmentDataMonthlyByEmp.length > 0) ? 'col-sm-4 border-right' : 'col-sm-12'">
                          <h5 class="fw-semi-bold">Broken Appointment Follow-ups</h5>
                          <b-card  class=" background-cover" v-if="((brokenAppointmentDataMonthly && brokenAppointmentDataMonthly.totalCalls > 0) || (brokenAppointmentScheduledDataMonthly && brokenAppointmentScheduledDataMonthly.length > 0))">
                              <!--
                              <p class="fs-mini fw-semi-bold">Total calls made: {{brokenAppointmentDataMonthly.totalCalls}} call(s)</p>
                               -->
                               <p class="fs-mini fw-semi-bold">Total calls made: <b-button id="bacalls-monthly" variant="default" class="mb-xs mr-xs btn-xs"><span class="fs-mini fw-semi-bold" >{{brokenAppointmentDataMonthly.totalCalls}} follow-up(s)</span></b-button></p> 
                                <b-popover target="bacalls-monthly" triggers="focus" placement="top" v-if="brokenAppointmentTasksDataMonthly && brokenAppointmentTasksDataMonthly.length > 0">
                                  <template v-slot:title><b>Follow-up(s) made</b></template>              
                                  <table class="table">
                                    <thead>
                                      <tr>                                          
                                        <th>Patient</th>                                          
                                        <th>Followed-up on</th>
                                        <th><span class="glyphicon glyphicon-user mr-2 mb-1"></span>Team member</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(appt, index) in brokenAppointmentTasksDataMonthly" :key="`od-${ appt.TeamioPatientID}-${ index }`">                                          
                                        <td>{{formatName(appt.Patient)}}</td>                                          
                                        <td>{{appt.CreatedAt | dateformat(dateFormatStr)}}</td>
                                        <td>{{appt.Employee}}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </b-popover>
                                <p class="fs-mini fw-semi-bold">Total scheduled: 
                                  <b-button id="bascheduled-monthly" variant="default" class="mb-xs mr-xs btn-xs">
                                    <span v-if="( (brokenAppointmentScheduledDataMonthly && brokenAppointmentScheduledDataMonthly.length === 0) || (!brokenAppointmentScheduledDataMonthly) )" class="fs-mini fw-semi-bold" >0 appointment(s)</span>
                                    <span v-else-if="brokenAppointmentScheduledDataMonthly && brokenAppointmentScheduledDataMonthly.length > 0" class="fs-mini fw-semi-bold" >{{brokenAppointmentScheduledDataMonthly.length}} appointment(s)</span>
                                  </b-button>
                                  {{sumArrValue(brokenAppointmentScheduledDataMonthly, 'AppointmentValue') | money}}
                                </p>
                                <b-popover target="bascheduled-monthly" triggers="focus" placement="top" v-if="brokenAppointmentScheduledDataMonthly && brokenAppointmentScheduledDataMonthly.length > 0">
                                  <template v-slot:title><b>Appointment(s) Scheduled</b></template>              
                                  <table class="table">
                                  <thead>
                                    <tr>                                          
                                      <th>Patient</th>                                          
                                      <th>Appointment Value</th>
                                      <th>Created on</th>

                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(appt, index) in brokenAppointmentScheduledDataMonthly" :key="`bamonthly-${appt.TeamioPatientID}-${ index }`">                                          
                                      <td>{{formatName(appt.Patient)}}
                                     </td>                                          
                                      <td><span class="text-success fw-semi-bold">{{appt.AppointmentValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td>  
                                      <td>{{appt.UpdatedAt | dateformat(dateFormatStr)}}</td>                                                              
                                    </tr>
                                  </tbody>
                                </table>
                              </b-popover>                               
                            <div class="chart-panel">
                              <PieChart :chartdata="brokenAppointmentDataMonthly.chartData" :options="chartOptions" :styles="chartStyles" :key="1"/>
                            </div>
                          </b-card>
                          <b-card class="background-cover" v-else>
                            <EmptyState :restricted="!$can('view', 'broken_appointment')" subject="broken_appointment" />
                          </b-card>
                        </div>
                        <div class="col-sm-8" v-if="brokenAppointmentDataMonthlyByEmp && brokenAppointmentDataMonthlyByEmp.length > 0">
                            <h5 class="text-success fw-semi-bold">Breakdown by Team member(s)</h5>
                            <div class="slider-panel slider-panel9 team-member-slider">
                                <b-card  class="background-cover" v-for="(employee, index) in this.brokenAppointmentDataMonthlyByEmp" :key="`employee-${index}`">
                                    <div class="person-name">
                                        <!--<img data-v-5834cfff="" src="/img/a5.84f014f0.jpg" alt="..." class="rounded-circle">-->
                                        <span class="glyphicon glyphicon-user mr-2"></span>
                                        <div>
                                          <h6>{{employee.name}}</h6>
                                          <p class="fw-semi-bold">{{employee.totalCalls}} follow-ups - Conversion Rate {{employee.conversionRate}}%</p>
                                        </div>
                                      </div>                                  
                                      <div class="chart-panel">                                        
                                        <ChartJSBarChart v-if="currentTab==3" :chartData="transformBarChartData(employee.chartData)" />
                                      </div>
                                </b-card>
                            </div>                          
                          </div>                                   
                    </div>
                </div>  
                <!--
                <div class="info-section">              
                    <div class="row">                  
                        <div class="col-sm-4">
                          <h6 class="text-success fw-semi-bold">Insurance Verifications <sup class="ml-1 headerLabel text-danger">Coming soon!</sup></h6>
                          <b-card  class=" background-cover">
                              <div class="person-name">
                                  <div>
                                    <h6>40 Verified</h6>
                                  </div>
                                </div>                                  
                                <div class="chart-panel">
                                    <InsightMSBarChart v-if="currentTab==3" :chartData="getMonthToDateBarChartData3"></InsightMSBarChart>
                                </div>
                          </b-card>
                        </div>                           
                    </div>
                </div>
                -->
            </b-tab>
            <!-- THIRD TAB END -->
            <!-- FOURTH TAB START -->
              <b-tab title="Custom Reports" @click="changeTab(4)"/>
            <!-- FOURTH TAB END -->            
          </b-tabs>
        </section>
        <!-- TAB PANEL END -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable */

/*
import 'imports-loader?jQuery=jquery,this=>window!flot';
import 'imports-loader?jQuery=jquery,this=>window!flot/jquery.flot.time';
import 'imports-loader?jQuery=jquery,this=>window!flot/jquery.flot.resize';
import 'imports-loader?jQuery=jquery,this=>window!jquery.flot.animator/jquery.flot.animator';
import 'imports-loader?jQuery=jquery,this=>window!flot/jquery.flot.crosshair';
import 'imports-loader?jQuery=jquery,this=>window!flot/jquery.flot.symbol';
import 'imports-loader?jQuery=jquery,this=>window!flot/jquery.flot.selection';
import 'imports-loader?jQuery=jquery,this=>window!flot/jquery.flot.pie';
import 'imports-loader?jQuery=jquery,this=>window!jquery.flot-orderBars/js/jquery.flot.orderBars';
import 'imports-loader?jQuery=jquery,this=>window!jquery-sparkline';
*/

import PieChart from './components/InsightPieChart';
import ChartJSBarChart from './components/ChartJSBarChart.vue';
import Vue from "vue";
import DatePicker from "vue2-datepicker";
// eslint-disable-next-line
import lifestyle from '../../assets/cards/lifestyle.jpg';
import { mapState, mapActions, mapMutations } from 'vuex';
import moment from 'moment-timezone';
import ErrorDisplay from "@/components/ErrorDisplay/ErrorDisplay";
import mixin from '../../mixin.js';
import Slick from 'vue-slick';
import TeamInsightsSkeleton from './TeamInsightsSkeleton.vue';
import EmptyState from '@/components/EmptyState/EmptyState.vue';

export default {
  name:'TeamInsights',
  components:{
    PieChart,
    DatePicker,
    ChartJSBarChart,
    ErrorDisplay,
    TeamInsightsSkeleton,
    EmptyState
  },
  mixins: [mixin],

  mounted(){
    /*
    this.todayInitSlider();
    $(window).trigger('resize');
    */
  },

  created() {
    if(this.allSettings)
      this.init();
  },

  data(){
    return {
      results: [],
      busy: false,
      weekToDateSelectedSubTabIndex: 0,
      monthToDateSelectedSubTabIndex: 0,
      currentTab:1,
      currentSubTab:1,
      datepickerFromText:'',
      datepickerToText:'',
      showReport: false,
      trackWidth: 0,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          }
        },
        legend: {
          display: true,
          position: 'bottom',
          align: 'center',
          fullWidth: true,
          labels: {
            padding: 12,
            boxWidth: 14,
            fontFamily: "'Inter', 'Segoe UI', Roboto, -apple-system, sans-serif",
            fontSize: 12,
            fontColor: '#334155'
          }
        },
        tooltips: {
          backgroundColor: 'rgba(15, 23, 42, 0.9)',
          titleFontFamily: "'Inter', 'Segoe UI', Roboto, sans-serif",
          titleFontSize: 13,
          titleFontColor: '#fff',
          bodyFontFamily: "'Inter', 'Segoe UI', Roboto, sans-serif",
          bodyFontSize: 12,
          bodyFontColor: '#e2e8f0',
          borderColor: 'rgba(255, 255, 255, 0.1)',
          borderWidth: 1,
          cornerRadius: 6,
          xPadding: 10,
          yPadding: 8
        }
      },

      // lifestyle
    }
  },

  methods:{
    ...mapActions('teamio', ['runQuery']),
    ...mapMutations('teamio', ['emptyResults']),
    
    async init() {
      this.busy = true;
      this.resetError();
      let query = {
          type: 'TEAM_INSIGHTS',
          siteID: this.siteID,
          d: moment().tz(this.allSettings.GENERAL_TIMEZONE.PropertyValue).format('YYYY-MM-DD')
      };
      //console.log('query', query);
      this.emptyResults();
      try {
        this.results = await this.runQuery(query);
      } finally {
        this.busy = false;
      }
    },

    selectDate(val, key) {
       //console.log(val, key);
      Vue.set(this, key, val.toLocaleDateString());
    },

    changeTab(tabIndex) {
      this.currentTab = tabIndex;
      if(this.currentTab==2){
        this.changeSubTab(2.1);
        this.weekToDateSelectedSubTabIndex = 0;
        //this.weekToDateInitSlider();
      } else if(this.currentTab==3){
        this.changeSubTab(3.1);
        //this.monthToDateInitSlider();
        this.monthToDateSelectedSubTabIndex = 0;
      } else if(this.currentTab==4) {
        this.$router.push({
          name: 'TeamInsightsCustomReports'
        });
      }
      $(window).trigger('resize');
      // this.currentSubTab = tabIndex;
    },

    changeSubTab(tabIndex){
      this.currentSubTab = tabIndex;
      $(window).trigger('resize');
    },

    todayInitSlider() {
        //console.log('todayInitSlider', $('.slider-panel1'));
        /* eslint-disable */
        $('.slider-panel1').not('.slick-initialized').slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: window.innerWidth < 1161 ? 1 : 2,
          slidesToScroll: window.innerWidth < 1161 ? 1 : 2,
        });
        $('.slider-panel2').not('.slick-initialized').slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: window.innerWidth < 1161 ? 1 : 2,
          slidesToScroll: window.innerWidth < 1161 ? 1 : 2
        });
      },
    initialiseSlider(){
        //console.log('slider-class');
        $('.slider-panel-pre-auth').not('.slick-initialized').slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: window.innerWidth < 700 ? 1 : 2,
          slidesToScroll: window.innerWidth < 700 ? 1 : 2,
          // variableWidth: true,
          // centerMode: true,
        });
        $(window).trigger('resize');
        $(".slider-panel-pre-auth").slick("refresh");
        $('.slider-panel-pre-auth').slick('setPosition');
    },
    weekToDateInitSlider() {
      $('.slider-panel3').not('.slick-initialized').slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: window.innerWidth < 1161 ? 1 : 2,
          slidesToScroll: window.innerWidth < 1161 ? 1 : 2,
        //   responsive: [ { breakpoint: 1161, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        // { breakpoint: 1160, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        // { breakpoint: 438, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        // { breakpoint: 270, settings: { slidesToShow: 1, slidesToScroll: 1 } } ]
      });
      $('.slider-panel4').not('.slick-initialized').slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: window.innerWidth < 1161 ? 1 : 2,
          slidesToScroll: window.innerWidth < 1161 ? 1 : 2,
      });
      $('.slider-panel5').not('.slick-initialized').slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: window.innerWidth < 1161 ? 1 : 2,
          slidesToScroll: window.innerWidth < 1161 ? 1 : 2,
      });
       $('.slider-panel6').not('.slick-initialized').slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: window.innerWidth < 1161 ? 1 : 2,
          slidesToScroll: window.innerWidth < 1161 ? 1 : 2,
      });
    },
    monthToDateInitSlider() {
     $('.slider-panel7').not('.slick-initialized').slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: window.innerWidth < 1161 ? 1 : 2,
          slidesToScroll: window.innerWidth < 1161 ? 1 : 2,
      });
      $('.slider-panel8').not('.slick-initialized').slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: window.innerWidth < 1161 ? 1 : 2,
          slidesToScroll: window.innerWidth < 1161 ? 1 : 2,
      });
      $('.slider-panel9').not('.slick-initialized').slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: window.innerWidth < 1161 ? 1 : 2,
          slidesToScroll: window.innerWidth < 1161 ? 1 : 2,
      });
      $('.slider-panel10').not('.slick-initialized').slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: window.innerWidth < 1161 ? 1 : 2,
          slidesToScroll: window.innerWidth < 1161 ? 1 : 2,
      });
    },

    /*
      Given object 
      {
        Wednesday: Array[4],
        Monday: Array[3],
      }
      it will return
      {
        Monday: Array[3],
        Wednesday: Array[4]
      }

    */

    sortByDay(o) {
      let daysInOrder = _.orderBy(_.keys(o), function(item) {
        return moment().day(item).weekday();
      });

      let returnObject = {};
      let q = daysInOrder.forEach(function(k) {
        returnObject[k] = o[k];
      });
      return returnObject;
    },

    /* below takes an array of days and returns sorted array */

    sortDays(d) {
      return _.orderBy(d, function(item) {
        return moment().day(item).weekday();
      });
    },

    sortByWeek(o) {
      let weeksInOrder = _.orderBy(_.keys(o), function(item) {
        return item.replace(/[a-zA-Z]+/, '');
      });

      let returnObject = {};
      let q = weeksInOrder.forEach(function(k) {
        returnObject[k] = o[k];
      });
      return returnObject;
    },

    makeChartData(d) {
      return {
        labels: _.keys(d),
        datasets: [
          {
            label: "Data One",
            // Teamio Huddle-style color palette - consistent across all charts
            backgroundColor: [
              '#3abf94',  // Primary green (brand)
              '#3b82f6',  // Blue
              '#8b5cf6',  // Purple
              '#f59e0b',  // Amber
              '#64748b',  // Slate
              '#06b6d4',  // Cyan
              '#ec4899',  // Pink
              '#10b981',  // Emerald
              '#6366f1',  // Indigo
              '#78716c',  // Stone
            ],
            data: _.values(d)
          }
        ]
      }
    },

    makeChartDataWeekly(tasksData, scheduledData, k, claimBased, paymentBased, funcName='') {
      //console.log(`Function name called from:${funcName}`);
      let callsByEmployee = _.groupBy(tasksData, 'CreatedByEmpID');
      let scheduledByEmployee = _.groupBy(scheduledData, 'CreatedByEmpID');

      let callsByDayByEmp = _.groupBy(callsByEmployee[k], function(o) {
        return moment(o.CreatedAt).format('dddd')
      });

      let scheduledByDayByEmp = _.groupBy(scheduledByEmployee[k], function(o) {
        if(o.AppointmentScheduled === 1)
          return moment(o.UpdatedAt).format('dddd')
      });

      let claimReceivedByDayByEmp = _.groupBy(scheduledByEmployee[k], function(o) {
        if(o.ClaimReceived === 1)
          return moment(o.UpdatedAt).format('dddd')
      });

      let paidByDayByEmp = _.groupBy(scheduledByEmployee[k], function(o) {
        if(o.PatientBalanceAmountPaid > 0)
          return moment(o.UpdatedAt).format('dddd')
      });

      let ticks = [];
      let data = [];
      const retObj = new Object();
      let tempData = [];
      let counter = 5;
      let allDays = [];

      let callObj = {
        label: 'Call',
        data: [],
        bars: {
            show: true,
            fill: 0.5,
            lineWidth: 0,
            order: 1,
        }
      };

      let scheduledObj = {
        label: 'Scheduled',
        data: [],
        bars: {
          show: true,
          fill: 0.5,
          lineWidth: 0,
          order: 2,
        },
      };

      let receivedObj = {
        label: 'Received',
        data: [],
        bars: {
          show: true,
          fill: 0.5,
          lineWidth: 0,
          order: 2,
        },
      };

      let paidObj = {
        label: 'Paid',
        data: [],
        bars: {
          show: true,
          fill: 0.5,
          lineWidth: 0,
          order: 2,
        },
      };

      if(claimBased) {
        allDays = _.union(_.keys(callsByDayByEmp), _.keys(claimReceivedByDayByEmp));
      }
      else if(paymentBased) {
        allDays = _.union(_.keys(callsByDayByEmp), _.keys(paidByDayByEmp));
      }
      else {
        allDays = _.union(_.keys(callsByDayByEmp), _.keys(scheduledByDayByEmp));
      }

      allDays = this.sortDays(allDays);

      allDays.forEach(function(key) {
        let saumil1;
        let temp = [counter, key];
        ticks.push(temp);
        if(key in callsByDayByEmp) {
          callObj.data.push([counter, callsByDayByEmp[key].length]);
          if(claimBased) {
            if(key in claimReceivedByDayByEmp) {
              saumil1 = [counter, claimReceivedByDayByEmp[key].length];
              receivedObj.data.push(saumil1);
            } else {
              receivedObj.data.push([counter,0]);
            }
          } 
          /*
          else if (paymentBased) {
            if(key in paidByDayByEmp) {
              saumil1 = [counter, paidByDayByEmp[key].length];
              paidObj.data.push(saumil1);
            } else {
              paidObj.data.push([counter, 0]);
            }
          }
            */
          else {
            // appointment related
            if(key in scheduledByDayByEmp) {
              saumil1 = [counter, scheduledByDayByEmp[key].length];
              scheduledObj.data.push(saumil1);
            } else {
              scheduledObj.data.push([counter, 0]);
            }
          }
        } else {
          callObj.data.push([counter,0]); // no calls found for this day

          //now check if key found in scheduled

          if(key in scheduledByDayByEmp) {
              saumil1 = [counter, scheduledByDayByEmp[key].length];
              scheduledObj.data.push(saumil1);
          } else { //no key found in 
            if(claimBased) {
              if(key in claimReceivedByDayByEmp) {
                saumil1 = [counter, claimReceivedByDayByEmp[key].length];
                receivedObj.data.push(saumil1);
              } else {
                receivedObj.data.push([counter,0]);
              }
            }
            /*
            else if (paymentBased) {
              if(key in paidByDayByEmp) {
                saumil1 = [counter, paidByDayByEmp[key].length];
                paidObj.data.push(saumil1);
              } else {
                paidObj.data.push([counter, 0]);
              }
            }
              */
            else {
              scheduledObj.data.push([counter, 0]);
            }
          }
        }
        counter = counter + 5;         
      });
      

      //console.log(`retObject at beginning2: ${JSON.stringify(retObj, null, 2)}`);
      //console.dir(retObj);      

      if(claimBased) {
        tempData.push(callObj);
        tempData.push(receivedObj);
        retObj.ticks = ticks;
        retObj.data = tempData;
      } else if (paymentBased) {
        tempData.push(callObj);
        //tempData.push(paidObj);
        retObj.ticks = ticks;
        retObj.data = tempData;
      } else {
        tempData.push(callObj);
        tempData.push(scheduledObj);
        retObj.ticks = ticks;
        retObj.data = tempData;
      }
      return retObj;
    },

    makeChartDataMonthly(tasksData, scheduledData, k, claimBased, paymentBased, funcName='') {

      let callsByEmployee = _.groupBy(tasksData, 'CreatedByEmpID');
      let scheduledByEmployee = _.groupBy(scheduledData, 'CreatedByEmpID');

      let callsByWeekByEmp = _.groupBy(callsByEmployee[k], function(o) {
        //return 'Week ' + Math.ceil(moment(o.CreatedAt).date() / 7)
        let str1 = 'Week ';
        let str2 = moment(o.CreatedAt).weeks() - moment(o.CreatedAt).add(0, 'month').startOf('month').weeks() + 1;
        let str3 = str1 + str2;
        return str3;
      });

      // Now order the days so that Week 2 shows up before Week 3 etc.
      callsByWeekByEmp = this.sortByWeek(callsByWeekByEmp);

      let scheduledByWeekByEmp = _.groupBy(scheduledByEmployee[k], function(o) {
        if(o.AppointmentScheduled === 1) {
          //return 'Week ' + Math.ceil(moment(o.UpdatedAt).date() / 7)
          let str1 = 'Week ';
          let str2 = moment(o.UpdatedAt).weeks() - moment(o.UpdatedAt).add(0, 'month').startOf('month').weeks() + 1;
          let str3 = str1 + str2;
          return str3;
        }
      });

      let claimReceivedByWeekByEmp = _.groupBy(scheduledByEmployee[k], function(o) {
        if(o.ClaimReceived === 1) {
          //return 'Week ' + Math.ceil(moment(o.UpdatedAt).date() / 7)
          let str1 = 'Week ';
          let str2 = moment(o.UpdatedAt).weeks() - moment(o.UpdatedAt).add(0, 'month').startOf('month').weeks() + 1;
          let str3 = str1 + str2;
          return str3;
        }
      });

      let paidByWeekByEmp = _.groupBy(scheduledByEmployee[k], function(o) {
        if(o.PatientBalanceAmountPaid > 0) {
          //return 'Week ' + Math.ceil(moment(o.UpdatedAt).date() / 7)
          let str1 = 'Week ';
          let str2 = moment(o.UpdatedAt).weeks() - moment(o.UpdatedAt).add(0, 'month').startOf('month').weeks() + 1;
          let str3 = str1 + str2;
          return str3;
        }
      });


      let ticks = [];
      let data = [];
      const retObj = new Object();
      let tempData = [];
      let counter = 5;
      let allDays = [];

      let callObj = {
        label: 'Call',
        data: [],
        bars: {
            show: true,
            fill: 0.5,
            lineWidth: 0,
            order: 1,
        }
      };

      let scheduledObj = {
        label: 'Scheduled',
        data: [],
        bars: {
          show: true,
          fill: 0.5,
          lineWidth: 0,
          order: 2,
        },
      };

      let receivedObj = {
        label: 'Received',
        data: [],
        bars: {
          show: true,
          fill: 0.5,
          lineWidth: 0,
          order: 2,
        },
      };

      let paidObj = {
        label: 'Paid',
        data: [],
        bars: {
          show: true,
          fill: 0.5,
          lineWidth: 0,
          order: 2,
        },
      };

     if(claimBased) {
        allDays = _.union(_.keys(callsByWeekByEmp), _.keys(claimReceivedByWeekByEmp));
      }
      else if(paymentBased) {
        allDays = _.union(_.keys(callsByWeekByEmp), _.keys(paidByWeekByEmp));
      }
      else {
        allDays = _.union(_.keys(callsByWeekByEmp), _.keys(scheduledByWeekByEmp));
      }

      allDays = this.sortDays(allDays);

      allDays.forEach(function(key) {
        let saumil1;
        let temp = [counter, key];
        ticks.push(temp);
        if(key in callsByWeekByEmp) {
          callObj.data.push([counter, callsByWeekByEmp[key].length]);
          if(claimBased) {
            if(key in claimReceivedByWeekByEmp) {
              saumil1 = [counter, claimReceivedByWeekByEmp[key].length];
              receivedObj.data.push(saumil1);
            } else {
              receivedObj.data.push([counter,0]);
            }
          } 
          else if (paymentBased) {
            if(key in paidByWeekByEmp) {
              saumil1 = [counter, paidByWeekByEmp[key].length];
              paidObj.data.push(saumil1);
            } else {
              paidObj.data.push([counter, 0]);
            }
          }
          else {
            // appointment related
            if(key in scheduledByWeekByEmp) {
              saumil1 = [counter, scheduledByWeekByEmp[key].length];
              scheduledObj.data.push(saumil1);
            } else {
              scheduledObj.data.push([counter, 0]);
            }
          }
        } else {
          callObj.data.push([counter,0]); // no calls found for this day

          //now check if key found in scheduled

          if(key in scheduledByWeekByEmp) {
              saumil1 = [counter, scheduledByWeekByEmp[key].length];
              scheduledObj.data.push(saumil1);
          } else { 
            if(claimBased) {
                //receivedObj.data.push([counter, 0]);
                if(key in claimReceivedByWeekByEmp) {
                  saumil1 = [counter, claimReceivedByWeekByEmp[key].length];
                  receivedObj.data.push(saumil1);
                } else {
                  receivedObj.data.push([counter,0]);
                }
            }
            else if (paymentBased) {
              paidObj.data.push([counter, 0]);
            }
            else {
              scheduledObj.data.push([counter, 0]);
            }
          }
        }
        counter = counter + 5;         
      });  

      if(claimBased) {
        tempData.push(callObj);
        tempData.push(receivedObj);
        retObj.ticks = ticks;
        retObj.data = tempData;
      } else if (paymentBased) {
        tempData.push(callObj);
        //tempData.push(paidObj);
        retObj.ticks = ticks;
        retObj.data = tempData;
      } else {
        tempData.push(callObj);
        tempData.push(scheduledObj);
        retObj.ticks = ticks;
        retObj.data = tempData;
      }
      return retObj;
    },

    /*

    You need to transform this data into the format expected by Chart.js. Here's how you can do it:

    Extract Labels: The ticks array contains the labels for the x-axis. Extract the second element of each sub-array (e.g., 'Monday', 'Tuesday', etc.).

    Extract Datasets: The data array contains the datasets. Each dataset has a label and data property. Extract the label and the second element of each sub-array in the data property (e.g., 12, 19, etc.).

    */

    transformBarChartData(chartData) {
      //console.log('chartData', chartData);
      if(chartData.ticks) {
        const labels = chartData.ticks.map(tick => tick[1]); // Extract labels
        const datasets = chartData.data.map(dataset => ({
          label: dataset.label, // Dataset label
          backgroundColor: this.getBackgroundColor(dataset.label), // Assign a color
          data: dataset.data.map(point => point[1]) // Extract data points
        }));

        return {
          labels,
          datasets
        };
      }
    },

    getBackgroundColor(label) {
      // Muted color palette matching teamio theme
      const colors = {
        Call: '#3abf94',        // Primary green
        Scheduled: '#5cc9a7',   // Light green
        Received: '#14b8a6',    // Teal
        Paid: '#2d9a77'         // Dark green
      };
      return colors[label] || '#94a3b8'; // Light slate default
    }

    // end of all Methods functions
  },

  computed:{
    chartStyles() {
      return {
        width: '100%',
        height: window.innerWidth < 768 ? '280px' : '320px'
      }
    },

    dataToDisplay() {
      if(this.results && this.results.data && this.results.data.length > 0)
          return this.results.data;
    },

    insightsDataDaily() {
      if(this.dataToDisplay && this.dataToDisplay.length > 0 && this.dataToDisplay[1]) {
        return this.dataToDisplay[0];
      }
    },

    insightsDataWeekly() {
      if(this.dataToDisplay && this.dataToDisplay.length > 0 && this.dataToDisplay[1]) {
        return this.dataToDisplay[1];
      }
    },

    insightsDataMonthly() {
      if(this.dataToDisplay && this.dataToDisplay.length > 0 && this.dataToDisplay[1]) {
        return this.dataToDisplay[2];
      }
    },

    siteStatuses() {
      if(this.dataToDisplay && this.dataToDisplay.length > 0 && this.dataToDisplay[1]) {
        return this.dataToDisplay[3];
      }
    },

    insightsScheduledDataDaily() {
      if(this.dataToDisplay && this.dataToDisplay.length > 0 && this.dataToDisplay[1]) {
        return this.dataToDisplay[4];
      }
    },

    insightsScheduledDataWeekly() {
      if(this.dataToDisplay && this.dataToDisplay.length > 0 && this.dataToDisplay[1]) {
        return this.dataToDisplay[5];
      }
    },

    insightsScheduledDataMonthly() {
      if(this.dataToDisplay && this.dataToDisplay.length > 0 && this.dataToDisplay[1]) {
        return this.dataToDisplay[6];
      }
    },

    overdueRecallTasksDataDaily() {
      if(this.insightsDataDaily)
        return this.insightsDataDaily.filter(t => t.TaskTypeID === 3);
    },

    overdueRecallScheduledDataDaily() {
      if(this.insightsScheduledDataDaily)
        return _.uniqBy(this.insightsScheduledDataDaily.filter(t => t.TaskTypeID === 3 && t.AppointmentScheduled === 1), 'TeamioPatientID');
    },

    overdueRecallTasksDataWeekly() {
      if(this.insightsDataWeekly)
        return this.insightsDataWeekly.filter(t => t.TaskTypeID === 3);
    },

    overdueRecallScheduledDataWeekly() {
      if(this.insightsScheduledDataWeekly)
        return _.uniqBy(this.insightsScheduledDataWeekly.filter(t => t.TaskTypeID === 3 && t.AppointmentScheduled === 1),'TeamioPatientID');
    },

    overdueRecallTasksDataMonthly() {
      if(this.insightsDataMonthly)
        return this.insightsDataMonthly.filter(t => t.TaskTypeID === 3);
    },

    overdueRecallScheduledDataMonthly() {
      if(this.insightsScheduledDataMonthly)
        return _.uniqBy(this.insightsScheduledDataMonthly.filter(t => t.TaskTypeID === 3 && t.AppointmentScheduled === 1), 'TeamioPatientID');
    },

    unscheduledTreatmentTasksDataDaily() {
      if(this.insightsDataDaily)
        return this.insightsDataDaily.filter(t => t.TaskTypeID === 4);
    },

    unscheduledTreatmentScheduledDataDaily() {
      if(this.insightsScheduledDataDaily)
        return _.uniqBy(this.insightsScheduledDataDaily.filter(t => t.TaskTypeID === 4 && t.AppointmentScheduled === 1), 'TeamioPatientID');
    },

    unscheduledTreatmentTasksDataWeekly() {
      if(this.insightsDataWeekly)
        return this.insightsDataWeekly.filter(t => t.TaskTypeID === 4);
    },

    unscheduledTreatmentScheduledDataWeekly() {
      if(this.insightsScheduledDataWeekly)
       return _.uniqBy(this.insightsScheduledDataWeekly.filter(t => t.TaskTypeID === 4 && t.AppointmentScheduled === 1),'TeamioPatientID');
    },

    unscheduledTreatmentTasksDataMonthly() {
      if(this.insightsDataMonthly)
        return this.insightsDataMonthly.filter(t => t.TaskTypeID === 4);
    },

    unscheduledTreatmentScheduledDataMonthly() {
      if(this.insightsScheduledDataMonthly)
        return _.uniqBy(this.insightsScheduledDataMonthly.filter(t => t.TaskTypeID === 4 && t.AppointmentScheduled === 1), 'TeamioPatientID');

    },

    outstandingClaimsTasksDataDaily() {
      if(this.insightsDataDaily)
        return this.insightsDataDaily.filter(t => t.TaskTypeID === 2);
    },

    outstandingClaimsClaimReceivedDataDaily() {
      if(this.insightsScheduledDataDaily)
        //return this.insightsScheduledDataDaily.filter(t => t.TaskTypeID === 2 && t.ClaimReceived === 1);
        return _.uniqBy(this.insightsScheduledDataDaily.filter(t => t.TaskTypeID === 2 && t.ClaimReceived === 1), 'ClaimNum');

    },

    outstandingClaimsTasksDataWeekly() {
      if(this.insightsDataWeekly)
        return this.insightsDataWeekly.filter(t => t.TaskTypeID === 2);
    },

    outstandingClaimsClaimReceivedDataWeekly() {
      if(this.insightsScheduledDataWeekly)
        //return this.insightsScheduledDataWeekly.filter(t => t.TaskTypeID === 2 && t.ClaimReceived === 1);
        return _.uniqBy(this.insightsScheduledDataWeekly.filter(t => t.TaskTypeID === 2 && t.ClaimReceived === 1), 'ClaimNum');

    },

    outstandingClaimsTasksDataMonthly() {
      if(this.insightsDataMonthly)
        return this.insightsDataMonthly.filter(t => t.TaskTypeID === 2);
    },

    outstandingClaimsClaimReceivedDataMonthly() {
      if(this.insightsScheduledDataMonthly)
        //return this.insightsScheduledDataMonthly.filter(t => t.TaskTypeID === 2 && t.ClaimReceived === 1);
        return _.uniqBy(this.insightsScheduledDataMonthly.filter(t => t.TaskTypeID === 2 && t.ClaimReceived === 1), 'ClaimNum');

    },

    preAuthOutstandingTasksDataDaily() {
      if(this.insightsDataDaily)
        return this.insightsDataDaily.filter(t => t.TaskTypeID === 5);
    },

    preAuthOutstandingClaimReceivedDataDaily() {
      if(this.insightsScheduledDataDaily)
        //return this.insightsScheduledDataDaily.filter(t => t.TaskTypeID === 5 && t.ClaimReceived === 1);
        return _.uniqBy(this.insightsScheduledDataDaily.filter(t => t.TaskTypeID === 5 && t.ClaimReceived === 1), 'ClaimNum');

    },

    preAuthOutstandingTasksDataWeekly() {
      if(this.insightsDataWeekly)
        return this.insightsDataWeekly.filter(t => t.TaskTypeID === 5);
    },

    preAuthOutstandingClaimReceivedDataWeekly() {
      if(this.insightsScheduledDataWeekly)
        //return this.insightsScheduledDataWeekly.filter(t => t.TaskTypeID === 5 && t.ClaimReceived === 1);
        return _.uniqBy(this.insightsScheduledDataWeekly.filter(t => t.TaskTypeID === 5 && t.ClaimReceived === 1), 'ClaimNum');
    },

    preAuthOutstandingTasksDataMonthly() {
      if(this.insightsDataMonthly)
        return this.insightsDataMonthly.filter(t => t.TaskTypeID === 5);
    },

    preAuthOutstandingClaimReceivedDataMonthly() {
      if(this.insightsScheduledDataMonthly)
        //return this.insightsScheduledDataMonthly.filter(t => t.TaskTypeID === 5 && t.ClaimReceived === 1);
        return _.uniqBy(this.insightsScheduledDataMonthly.filter(t => t.TaskTypeID === 5 && t.ClaimReceived === 1), 'ClaimNum');
    },

    preAuthReceivedTasksDataDaily() {
      if(this.insightsDataDaily)
        return this.insightsDataDaily.filter(t => t.TaskTypeID === 6);
    },

    preAuthReceivedTasksDataWeekly() {
      if(this.insightsDataWeekly)
        return this.insightsDataWeekly.filter(t => t.TaskTypeID === 6);
    },

    preAuthReceivedTasksDataMonthly() {
      if(this.insightsDataMonthly)
        return this.insightsDataMonthly.filter(t => t.TaskTypeID === 6);
    },

    preAuthReceivedScheduledDataDaily() {
     if(this.insightsScheduledDataDaily)
        return _.uniqBy(this.insightsScheduledDataDaily.filter(t => t.TaskTypeID === 6 && t.AppointmentScheduled === 1), 'TeamioPatientID');
    },

    preAuthReceivedScheduledDataWeekly() {
      if(this.insightsScheduledDataWeekly)
        return _.uniqBy(this.insightsScheduledDataWeekly.filter(t => t.TaskTypeID === 6 && t.AppointmentScheduled === 1),'TeamioPatientID');
    },

    preAuthReceivedScheduledDataMonthly() {
      if(this.insightsScheduledDataMonthly)
        return _.uniqBy(this.insightsScheduledDataMonthly.filter(t => t.TaskTypeID === 6 && t.AppointmentScheduled === 1), 'TeamioPatientID');
    },

    patientBalancesTasksDataDaily() {
      if(this.insightsDataDaily)
        return this.insightsDataDaily.filter(t => t.TaskTypeID === 7);
    },

    patientBalancesTasksDataWeekly() {
      if(this.insightsDataWeekly)
        return this.insightsDataWeekly.filter(t => t.TaskTypeID === 7);
    },

    patientBalancesTasksDataMonthly() {
      if(this.insightsDataMonthly)
        return this.insightsDataMonthly.filter(t => t.TaskTypeID === 7);
    },

    brokenAppointmentTasksDataDaily() {
      if(this.insightsDataDaily)
        return this.insightsDataDaily.filter(t => t.TaskTypeID === 8);
    },

    brokenAppointmentScheduledDataDaily() {
      if(this.insightsScheduledDataDaily)
        return _.uniqBy(this.insightsScheduledDataDaily.filter(t => t.TaskTypeID === 8 && t.AppointmentScheduled === 1), 'TeamioPatientID');
    },

    brokenAppointmentTasksDataWeekly() {
      if(this.insightsDataWeekly)
        return this.insightsDataWeekly.filter(t => t.TaskTypeID === 8);
    },

    brokenAppointmentScheduledDataWeekly() {
      if(this.insightsScheduledDataWeekly)
        return _.uniqBy(this.insightsScheduledDataWeekly.filter(t => t.TaskTypeID === 8 && t.AppointmentScheduled === 1),'TeamioPatientID');
    },

    brokenAppointmentTasksDataMonthly() {
      if(this.insightsDataMonthly)
        return this.insightsDataMonthly.filter(t => t.TaskTypeID === 8);
    },

    brokenAppointmentScheduledDataMonthly() {
      if(this.insightsScheduledDataMonthly)
        return _.uniqBy(this.insightsScheduledDataMonthly.filter(t => t.TaskTypeID === 8 && t.AppointmentScheduled === 1), 'TeamioPatientID');
    },

    overdueRecallStatuses() {
      if(this.siteStatuses) {
        let statuses = _.map(this.siteStatuses.filter(s => s.TaskTypeID === 3), 'ClientSystemFollowupStatus');
        let obj = {};
        let ret = _.map(statuses, function(val) {
          obj[val] = 0;
        });
        return obj;
      }
    },

    unscheduledTreatmentStatuses() {
      if(this.siteStatuses) {
        let statuses = _.map(this.siteStatuses.filter(s => s.TaskTypeID === 4), 'ClientSystemFollowupStatus');
        let obj = {};
        let ret = _.map(statuses, function(val) {
          obj[val] = 0;
        });
        return obj;
      }
    },

    outstandingClaimsStatuses() {
      if(this.siteStatuses) {
        let statuses = _.map(this.siteStatuses.filter(s => s.TaskTypeID === 2), 'ClientSystemFollowupStatus');
        let obj = {};
        let ret = _.map(statuses, function(val) {
          obj[val] = 0;
        });
        return obj;
      }
    },

    preAuthOutstandingStatuses() {
      if(this.siteStatuses) {
        let statuses = _.map(this.siteStatuses.filter(s => s.TaskTypeID === 5), 'ClientSystemFollowupStatus');
        let obj = {};
        let ret = _.map(statuses, function(val) {
          obj[val] = 0;
        });
        return obj;
      }
    },

    preAuthReceivedStatuses() {
      if(this.siteStatuses) {
        let statuses = _.map(this.siteStatuses.filter(s => s.TaskTypeID === 6), 'ClientSystemFollowupStatus');
        let obj = {};
        let ret = _.map(statuses, function(val) {
          obj[val] = 0;
        });
        return obj;
      }
    },

    patientBalancesStatuses() {
      if(this.siteStatuses) {
        let statuses = _.map(this.siteStatuses.filter(s => s.TaskTypeID === 7), 'ClientSystemFollowupStatus');
        let obj = {};
        let ret = _.map(statuses, function(val) {
          obj[val] = 0;
        });
        return obj;
      }
    },

    brokenAppointmentStatuses() {
      if(this.siteStatuses) {
        let statuses = _.map(this.siteStatuses.filter(s => s.TaskTypeID === 8), 'ClientSystemFollowupStatus');
        let obj = {};
        let ret = _.map(statuses, function(val) {
          obj[val] = 0;
        });
        return obj;
      }
    },

    overdueRecallDataDaily() {
      if(this.overdueRecallStatuses && this.overdueRecallTasksDataDaily) {
        let temp = _.clone(this.overdueRecallStatuses);
        let temp1 = _.merge(temp, _.countBy(this.overdueRecallTasksDataDaily, 'Status'));
        /*
        let scheduledStatusNameForThisSite = this.siteStatuses.filter(s => s.TaskTypeID === 3 && s.TeamioFollowupStatusID == 1)[0].ClientSystemFollowupStatus;
        if(temp1[scheduledStatusNameForThisSite] === 0)
          delete temp1[scheduledStatusNameForThisSite];
        */
        /*
        // Now we need to update the count of Appointment Scheduled separately because that's based on a diff flag
        let totalScheduled = this.overdueRecallTasksDataDaily.filter(t => t.AppointmentScheduled === 1);
        
        temp1[scheduledStatusNameForThisSite] = totalScheduled.length;
        */
        let o = {
          totalCalls: _.sum(_.values(temp1)),
          chartData: this.makeChartData(temp1)
        };
        return o;
      }
    },

    overdueRecallDataWeekly() {
      if(this.overdueRecallStatuses && this.overdueRecallTasksDataWeekly) {
        let temp = _.clone(this.overdueRecallStatuses);
        let temp1 = _.merge(temp, _.countBy(this.overdueRecallTasksDataWeekly, 'Status'));
        let o = {
          totalCalls: _.sum(_.values(temp1)),
          chartData: this.makeChartData(temp1)
        };
        return o;
      }
    },

    overdueRecallDataMonthly() {
      if(this.overdueRecallStatuses && this.overdueRecallTasksDataMonthly) {
        let temp = _.clone(this.overdueRecallStatuses);
        let temp1 = _.merge(temp, _.countBy(this.overdueRecallTasksDataMonthly, 'Status'));
        let o = {
          totalCalls: _.sum(_.values(temp1)),
          chartData: this.makeChartData(temp1)
        };
        return o;
      }
    },

    overdueRecallScheduledMonthly() {
      return this.overdueRecallTasksDataMonthly.filter(t => t.AppointmentScheduled === 1).length;
    },

    unscheduledTreatmentDataDaily() {
      if(this.unscheduledTreatmentStatuses && this.unscheduledTreatmentTasksDataDaily) {
        let temp = _.clone(this.unscheduledTreatmentStatuses);
        let temp1 = _.merge(temp, _.countBy(this.unscheduledTreatmentTasksDataDaily, 'Status'));
        let o = {
          totalCalls: _.sum(_.values(temp1)),
          chartData: this.makeChartData(temp1)
        };
        return o;
      }
    },

    unscheduledTreatmentDataWeekly() {
      if(this.unscheduledTreatmentStatuses && this.unscheduledTreatmentTasksDataWeekly) {
        let temp = _.clone(this.unscheduledTreatmentStatuses);
        let temp1 = _.merge(temp, _.countBy(this.unscheduledTreatmentTasksDataWeekly, 'Status'));
        let o = {
          totalCalls: _.sum(_.values(temp1)),
          chartData: this.makeChartData(temp1)
        };
        return o;
      }
    },

    unscheduledTreatmentDataMonthly() {
      if(this.unscheduledTreatmentStatuses && this.unscheduledTreatmentTasksDataMonthly) {
        let temp = _.clone(this.unscheduledTreatmentStatuses);
        let temp1 = _.merge(temp, _.countBy(this.unscheduledTreatmentTasksDataMonthly, 'Status'));
        let o = {
          totalCalls: _.sum(_.values(temp1)),
          chartData: this.makeChartData(temp1)
        };
        return o;
      }
    },

    outstandingClaimsDataDaily() {
      if(this.outstandingClaimsStatuses && this.outstandingClaimsTasksDataDaily) {
        let temp = _.clone(this.outstandingClaimsStatuses);
        let temp1 = _.merge(temp, _.countBy(this.outstandingClaimsTasksDataDaily, 'Status'));
        let o = {
          totalCalls: _.sum(_.values(temp1)),
          chartData: this.makeChartData(temp1)
        };
        return o;
      }
    },

    outstandingClaimsDataWeekly() {
      if(this.outstandingClaimsStatuses && this.outstandingClaimsTasksDataWeekly) {
        let temp = _.clone(this.outstandingClaimsStatuses);
        let temp1 = _.merge(temp, _.countBy(this.outstandingClaimsTasksDataWeekly, 'Status'));
        let o = {
          totalCalls: _.sum(_.values(temp1)),
          chartData: this.makeChartData(temp1)
        };
        return o;
      }
    },

    outstandingClaimsDataMonthly() {
      if(this.outstandingClaimsStatuses && this.outstandingClaimsTasksDataMonthly) {
        let temp = _.clone(this.outstandingClaimsStatuses);
        let temp1 = _.merge(temp, _.countBy(this.outstandingClaimsTasksDataMonthly, 'Status'));
        let o = {
          totalCalls: _.sum(_.values(temp1)),
          chartData: this.makeChartData(temp1)
        };
        return o;
      }
    },

    preAuthOutstandingDataDaily() {
      
      if(this.preAuthOutstandingStatuses && this.preAuthOutstandingTasksDataDaily) {
        let temp = _.clone(this.preAuthOutstandingStatuses);
        let temp1 = _.merge(temp, _.countBy(this.preAuthOutstandingTasksDataDaily, 'Status'));
        let o = {
          totalCalls: _.sum(_.values(temp1)),
          chartData: this.makeChartData(temp1)
        };
        return o;
      }

    },

    preAuthOutstandingDataWeekly() {
      if(this.preAuthOutstandingStatuses && this.preAuthOutstandingTasksDataWeekly) {
        let temp = _.clone(this.preAuthOutstandingStatuses);
        let temp1 = _.merge(temp, _.countBy(this.preAuthOutstandingTasksDataWeekly, 'Status'));
        let o = {
          totalCalls: _.sum(_.values(temp1)),
          chartData: this.makeChartData(temp1)
        };
        return o;
      }
    },

    preAuthOutstandingDataMonthly() {
      if(this.preAuthOutstandingStatuses && this.preAuthOutstandingTasksDataMonthly) {
        let temp = _.clone(this.preAuthOutstandingStatuses);
        let temp1 = _.merge(temp, _.countBy(this.preAuthOutstandingTasksDataMonthly, 'Status'));
        let o = {
          totalCalls: _.sum(_.values(temp1)),
          chartData: this.makeChartData(temp1)
        };
        return o;
      }
    },

    preAuthReceivedDataDaily() {
      if(this.preAuthReceivedStatuses && this.preAuthReceivedTasksDataDaily) {
        let temp = _.clone(this.preAuthReceivedStatuses);
        let temp1 = _.merge(temp, _.countBy(this.preAuthReceivedTasksDataDaily, 'Status'));
        /*
        let scheduledStatusNameForThisSite = this.siteStatuses.filter(s => s.TaskTypeID === 3 && s.TeamioFollowupStatusID == 1)[0].ClientSystemFollowupStatus;
        if(temp1[scheduledStatusNameForThisSite] === 0)
          delete temp1[scheduledStatusNameForThisSite];
        */
        /*
        // Now we need to update the count of Appointment Scheduled separately because that's based on a diff flag
        let totalScheduled = this.overdueRecallTasksDataDaily.filter(t => t.AppointmentScheduled === 1);
        
        temp1[scheduledStatusNameForThisSite] = totalScheduled.length;
        */
        let o = {
          totalCalls: _.sum(_.values(temp1)),
          chartData: this.makeChartData(temp1)
        };
        return o;
      }
    },


    

    
    /*  
    commented because no longer providing this functoinality - will remove later
    patientBalancesPaidDaily() {
      if(this.insightsScheduledDataDaily)
        return this.insightsScheduledDataDaily.filter(t => t.TaskTypeID === 7 && t.PatientBalanceAmountPaid > 0);
    },
    */

    /*
    commented because no longer providing this functoinality - will remove later
    patientBalancesPaidSumDaily() {
      if(this.patientBalancesPaidDaily)
        return _.map(this.patientBalancesPaidDaily, 'PatientBalanceAmountPaid').reduce((a,b) => a + b, 0);
    }, 
    */   

    /*
    commented because no longer providing this functoinality - will remove later
    patientBalancesPaidWeekly() {
      if(this.insightsScheduledDataWeekly)
        return this.insightsScheduledDataWeekly.filter(t => t.TaskTypeID === 7 && t.PatientBalanceAmountPaid > 0);
    },

    patientBalancesPaidSumWeekly() {
      if(this.patientBalancesPaidWeekly)
        return _.map(this.patientBalancesPaidWeekly, 'PatientBalanceAmountPaid').reduce((a,b) => a + b, 0);
    },
    */ 

    /*
    commented because no longer providing this functoinality - will remove later
    patientBalancesPaidMonthly() {
      if(this.insightsScheduledDataMonthly)
        return this.insightsScheduledDataMonthly.filter(t => t.TaskTypeID === 7 && t.PatientBalanceAmountPaid > 0);
    },

    patientBalancesPaidSumMonthly() {
      if(this.patientBalancesPaidMonthly)
        return _.map(this.patientBalancesPaidMonthly, 'PatientBalanceAmountPaid').reduce((a,b) => a + b, 0);
    }, 
    */

    

    patientBalancesDataDaily() {
      if(this.patientBalancesStatuses && this.patientBalancesTasksDataDaily) {
        let temp = _.clone(this.patientBalancesStatuses);
        let temp1 = _.merge(temp, _.countBy(this.patientBalancesTasksDataDaily, 'Status'));
        let o = {
          totalCalls: _.sum(_.values(temp1)),
          chartData: this.makeChartData(temp1)
        };
        return o;
      }
    },

    patientBalancesDataWeekly() {
      if(this.patientBalancesStatuses && this.patientBalancesTasksDataWeekly) {
        let temp = _.clone(this.patientBalancesStatuses);
        let temp1 = _.merge(temp, _.countBy(this.patientBalancesTasksDataWeekly, 'Status'));
        let o = {
          totalCalls: _.sum(_.values(temp1)),
          chartData: this.makeChartData(temp1)
        };
        return o;
      }
    },

    patientBalancesDataMonthly() {
      if(this.patientBalancesStatuses && this.patientBalancesTasksDataMonthly) {
        let temp = _.clone(this.patientBalancesStatuses);
        let temp1 = _.merge(temp, _.countBy(this.patientBalancesTasksDataMonthly, 'Status'));
        let o = {
          totalCalls: _.sum(_.values(temp1)),
          chartData: this.makeChartData(temp1)
        };
        return o;
      }
    },

    brokenAppointmentDataDaily() {
      if(this.brokenAppointmentStatuses && this.brokenAppointmentTasksDataDaily) {
        let temp = _.clone(this.brokenAppointmentStatuses);
        let temp1 = _.merge(temp, _.countBy(this.brokenAppointmentTasksDataDaily, 'Status'));
        let o = {
          totalCalls: _.sum(_.values(temp1)),
          chartData: this.makeChartData(temp1)
        };
        return o;
      }
    },

    preAuthReceivedDataWeekly() {
      if(this.preAuthReceivedStatuses && this.preAuthReceivedTasksDataWeekly) {
        let temp = _.clone(this.preAuthReceivedStatuses);
        let temp1 = _.merge(temp, _.countBy(this.preAuthReceivedTasksDataWeekly, 'Status'));
        let o = {
          totalCalls: _.sum(_.values(temp1)),
          chartData: this.makeChartData(temp1)
        };
        return o;
      }
    },

    preAuthReceivedScheduledWeekly() {
      return this.preAuthReceivedScheduledDataWeekly.filter(t => t.AppointmentScheduled === 6).length;
    },

    brokenAppointmentDataWeekly() {
      if(this.brokenAppointmentStatuses && this.brokenAppointmentTasksDataWeekly) {
        let temp = _.clone(this.brokenAppointmentStatuses);
        let temp1 = _.merge(temp, _.countBy(this.brokenAppointmentTasksDataWeekly, 'Status'));
        let o = {
          totalCalls: _.sum(_.values(temp1)),
          chartData: this.makeChartData(temp1)
        };
        return o;
      }
    },

    preAuthReceivedDataMonthly() {
      if(this.preAuthReceivedStatuses && this.preAuthReceivedTasksDataMonthly) {
        let temp = _.clone(this.preAuthReceivedStatuses);
        let temp1 = _.merge(temp, _.countBy(this.preAuthReceivedTasksDataMonthly, 'Status'));
        let o = {
          totalCalls: _.sum(_.values(temp1)),
          chartData: this.makeChartData(temp1)
        };
        return o;
      }
    },

    preAuthReceivedScheduledMonthly() {
      return this.preAuthReceivedTasksDataMonthly.filter(t => t.AppointmentScheduled === 6).length;
    },

    brokenAppointmentDataMonthly() {
      if(this.brokenAppointmentStatuses && this.brokenAppointmentTasksDataMonthly) {
        let temp = _.clone(this.brokenAppointmentStatuses);
        let temp1 = _.merge(temp, _.countBy(this.brokenAppointmentTasksDataMonthly, 'Status'));
        let o = {
          totalCalls: _.sum(_.values(temp1)),
          chartData: this.makeChartData(temp1)
        };
        return o;
      }
    },

    overdueRecallDataDailyByEmp() {
      if(this.overdueRecallTasksDataDaily && this.overdueRecallStatuses && this.employees) {
        let ret = [];
        let temp = _.groupBy(this.overdueRecallTasksDataDaily, "CreatedByEmpID");
        var _this = this;
        _.keys(temp).forEach(function(k) {
          let c = _.countBy(temp[k], 'Status');
          let employeeName = _this.employees.filter(e => e.EmployeeID === k)[0].Name;
          let d = _.clone(_this.overdueRecallStatuses);
          _.merge(d, c);
          let o = {
            name: employeeName,
            totalCalls: _.sum(_.values(d)),
            chartData: _this.makeChartData(d)
          }
          ret.push(o);
        });
        return ret;
      }
    },

    overdueRecallDataWeeklyByEmp() {
      if(this.overdueRecallTasksDataWeekly && this.overdueRecallStatuses && this.employees) {
        let ret = [];
        let callsByEmployee = _.groupBy(this.overdueRecallTasksDataWeekly, "CreatedByEmpID");
        var _this = this;
        _.keys(callsByEmployee).forEach(function(k) {
          let c = _.countBy(callsByEmployee[k], 'Status');
          let employeeName = _this.employees.filter(e => e.EmployeeID === k)[0].Name;
          let d = _.clone(_this.overdueRecallStatuses);
          _.merge(d, c);

          // Calculate conversion
          let allCallsByThisEmp = callsByEmployee[k].length;
          //let allCallsScheduledByThisEmp = callsByEmployee[k].filter(c => c.AppointmentScheduled === 1).length;
          let allCallsScheduledByThisEmp = _this.overdueRecallScheduledDataWeekly.filter(c => c.CreatedByEmpID === k);
          let allCallsScheduledByThisEmpLength = allCallsScheduledByThisEmp.length;
          let conversionRate = Math.ceil((allCallsScheduledByThisEmpLength / allCallsByThisEmp) * 100);
          let o = {
            name: employeeName,
            totalCalls: _.sum(_.values(d)),
            conversionRate: conversionRate,
            chartData: _this.makeChartDataWeekly(_this.overdueRecallTasksDataWeekly, allCallsScheduledByThisEmp, k, false, false)
          }
          ret.push(o);
        });
        return ret;
      }
    },

    overdueRecallDataMonthlyByEmp() {
      if(this.overdueRecallTasksDataMonthly && this.overdueRecallStatuses && this.employees) {
        let ret = [];
        let callsByEmployee = _.groupBy(this.overdueRecallTasksDataMonthly, "CreatedByEmpID");
        var _this = this;
        _.keys(callsByEmployee).forEach(function(k) {
          let c = _.countBy(callsByEmployee[k], 'Status');
          let employeeName = _this.employees.filter(e => e.EmployeeID === k)[0].Name;
          let d = _.clone(_this.overdueRecallStatuses);
          _.merge(d, c);

          // Calculate conversion
          let allCallsByThisEmp = callsByEmployee[k].length;
          let allCallsScheduledByThisEmp = _this.overdueRecallScheduledDataMonthly.filter(c => c.CreatedByEmpID === k);
          let allCallsScheduledByThisEmpLength = allCallsScheduledByThisEmp.length;
          let conversionRate = Math.ceil((allCallsScheduledByThisEmpLength / allCallsByThisEmp) * 100);
          let o = {
            name: employeeName,
            totalCalls: _.sum(_.values(d)),
            conversionRate: conversionRate,
            chartData: _this.makeChartDataMonthly(_this.overdueRecallTasksDataMonthly, allCallsScheduledByThisEmp, k, false, false)
          }
          ret.push(o);
        });
        return ret;
      }
    },

    unscheduledTreatmentDataDailyByEmp() {
      if(this.unscheduledTreatmentTasksDataDaily && this.unscheduledTreatmentStatuses && this.employees) {
        let ret = [];
        let temp = _.groupBy(this.unscheduledTreatmentTasksDataDaily, "CreatedByEmpID");
        var _this = this;
        _.keys(temp).forEach(function(k) {
          let c = _.countBy(temp[k], 'Status');
          let employeeName = _this.employees.filter(e => e.EmployeeID === k)[0].Name;
          let d = _.clone(_this.unscheduledTreatmentStatuses);
          _.merge(d, c);
          let o = {
            name: employeeName,
            totalCalls: _.sum(_.values(d)),
            chartData: _this.makeChartData(d)
          }
          ret.push(o);
        });
        return ret;
      }
    },

    unscheduledTreatmentDataWeeklyByEmp() {
      if(this.unscheduledTreatmentTasksDataWeekly && this.unscheduledTreatmentStatuses && this.employees) {
        let ret = [];
        let callsByEmployee = _.groupBy(this.unscheduledTreatmentTasksDataWeekly, "CreatedByEmpID");
        var _this = this;
        _.keys(callsByEmployee).forEach(function(k) {
          let c = _.countBy(callsByEmployee[k], 'Status');
          let employeeName = _this.employees.filter(e => e.EmployeeID === k)[0].Name;
          let d = _.clone(_this.unscheduledTreatmentStatuses);
          _.merge(d, c);

          // Calculate conversion
          let allCallsByThisEmp = callsByEmployee[k].length;
          //let allCallsScheduledByThisEmp = callsByEmployee[k].filter(c => c.AppointmentScheduled === 1).length;
          let allCallsScheduledByThisEmp = _this.unscheduledTreatmentScheduledDataWeekly.filter(c => c.CreatedByEmpID === k);
          let allCallsScheduledByThisEmpLength = allCallsScheduledByThisEmp.length;
          let conversionRate = Math.ceil((allCallsScheduledByThisEmpLength / allCallsByThisEmp) * 100);
          let o = {
            name: employeeName,
            totalCalls: _.sum(_.values(d)),
            conversionRate: conversionRate,
            chartData: _this.makeChartDataWeekly(_this.unscheduledTreatmentTasksDataWeekly, allCallsScheduledByThisEmp, k, false, false)
          }
          ret.push(o);
        });
        return ret;
      }
    },

    unscheduledTreatmentDataMonthlyByEmp() {
      if(this.unscheduledTreatmentTasksDataMonthly && this.unscheduledTreatmentStatuses && this.employees) {
        let ret = [];
        let callsByEmployee = _.groupBy(this.unscheduledTreatmentTasksDataMonthly, "CreatedByEmpID");
        var _this = this;
        _.keys(callsByEmployee).forEach(function(k) {
          let c = _.countBy(callsByEmployee[k], 'Status');
          let employeeName = _this.employees.filter(e => e.EmployeeID === k)[0].Name;
          let d = _.clone(_this.unscheduledTreatmentStatuses);
          _.merge(d, c);

          // Calculate conversion
          let allCallsByThisEmp = callsByEmployee[k].length;
          let allCallsScheduledByThisEmp = _this.unscheduledTreatmentScheduledDataMonthly.filter(c => c.CreatedByEmpID === k);
          let allCallsScheduledByThisEmpLength = allCallsScheduledByThisEmp.length;
          let conversionRate = Math.ceil((allCallsScheduledByThisEmpLength / allCallsByThisEmp) * 100);
          let o = {
            name: employeeName,
            totalCalls: _.sum(_.values(d)),
            conversionRate: conversionRate,
            chartData: _this.makeChartDataMonthly(_this.unscheduledTreatmentTasksDataMonthly, allCallsScheduledByThisEmp, k, false, false)
          }
          ret.push(o);
        });
        return ret;
      }
    },

    outstandingClaimsDataDailyByEmp() {
      if(this.outstandingClaimsTasksDataDaily && this.outstandingClaimsStatuses && this.employees) {
        let ret = [];
        let temp = _.groupBy(this.outstandingClaimsTasksDataDaily, "CreatedByEmpID");
        var _this = this;
        _.keys(temp).forEach(function(k) {
          let c = _.countBy(temp[k], 'Status');
          let employeeName = _this.employees.filter(e => e.EmployeeID === k)[0].Name;
          let d = _.clone(_this.outstandingClaimsStatuses);
          _.merge(d, c);
          let o = {
            name: employeeName,
            totalCalls: _.sum(_.values(d)),
            chartData: _this.makeChartData(d)
          }
          ret.push(o);
        });
        return ret;
      }
    },

    outstandingClaimsDataWeeklyByEmp() {
      if(this.outstandingClaimsTasksDataWeekly && this.outstandingClaimsStatuses && this.employees) {
        let ret = [];
        let callsByEmployee = _.groupBy(this.outstandingClaimsTasksDataWeekly, "CreatedByEmpID");
        var _this = this;
        _.keys(callsByEmployee).forEach(function(k) {
          let c = _.countBy(callsByEmployee[k], 'Status');
          let employeeName = _this.employees.filter(e => e.EmployeeID === k)[0].Name;
          let d = _.clone(_this.outstandingClaimsStatuses);
          _.merge(d, c);

          // Calculate conversion
          let allCallsByThisEmp = callsByEmployee[k].length;
          let allCallsReceivedByThisEmp = _this.outstandingClaimsClaimReceivedDataWeekly.filter(c => c.CreatedByEmpID === k);
          let allCallsReceivedByThisEmpLength = allCallsReceivedByThisEmp.length;
          let conversionRate = Math.ceil((allCallsReceivedByThisEmpLength / allCallsByThisEmp) * 100);
          let chartData = _this.makeChartDataWeekly(_this.outstandingClaimsTasksDataWeekly, allCallsReceivedByThisEmp, k, true, false, 'outstandingClaimsDataWeeklyByEmp');
          const sam = {
            name: employeeName,
            totalCalls: _.sum(_.values(d)),
            totalReceived: allCallsReceivedByThisEmpLength,
            conversionRate: conversionRate,
            chartData: chartData
          }
          ret.push(sam);
        });
        return ret;
      }
    },

    outstandingClaimsDataMonthlyByEmp() {
      if(this.outstandingClaimsTasksDataMonthly && this.outstandingClaimsStatuses && this.employees) {
        let ret = [];
        let callsByEmployee = _.groupBy(this.outstandingClaimsTasksDataMonthly, "CreatedByEmpID");
        var _this = this;
        _.keys(callsByEmployee).forEach(function(k) {
          let c = _.countBy(callsByEmployee[k], 'Status');
          let employeeName = _this.employees.filter(e => e.EmployeeID === k)[0].Name;
          let d = _.clone(_this.outstandingClaimsStatuses);
          _.merge(d, c);

          // Calculate conversion
          let allCallsByThisEmp = callsByEmployee[k].length;
          let allCallsReceivedByThisEmp = _this.outstandingClaimsClaimReceivedDataMonthly.filter(c => c.CreatedByEmpID === k);
          let allCallsReceivedByThisEmpLength = allCallsReceivedByThisEmp.length;
          let conversionRate = Math.ceil((allCallsReceivedByThisEmpLength / allCallsByThisEmp) * 100);
          let o = {
            name: employeeName,
            totalCalls: _.sum(_.values(d)),
            totalReceived: allCallsReceivedByThisEmpLength,
            conversionRate: conversionRate,
            chartData: _this.makeChartDataMonthly(_this.outstandingClaimsTasksDataMonthly, allCallsReceivedByThisEmp, k, true, false)
          }
          ret.push(o);
        });
        return ret;
      }
    },

    preAuthOutstandingDataDailyByEmp() {
      if(this.preAuthOutstandingTasksDataDaily && this.preAuthOutstandingStatuses && this.employees) {
        let ret = [];
        let temp = _.groupBy(this.preAuthOutstandingTasksDataDaily, "CreatedByEmpID");
        var _this = this;
        _.keys(temp).forEach(function(k) {
          let c = _.countBy(temp[k], 'Status');
          let employeeName = _this.employees.filter(e => e.EmployeeID === k)[0].Name;
          let d = _.clone(_this.preAuthOutstandingStatuses);
          _.merge(d, c);
          let o = {
            name: employeeName,
            totalCalls: _.sum(_.values(d)),
            chartData: _this.makeChartData(d)
          }
          ret.push(o);
        });
        return ret;
      }
    },

    preAuthOutstandingDataWeeklyByEmp() {
      if(this.preAuthOutstandingTasksDataWeekly && this.preAuthOutstandingStatuses && this.employees) {
        let ret = [];
        let callsByEmployee = _.groupBy(this.preAuthOutstandingTasksDataWeekly, "CreatedByEmpID");
        var _this = this;
        _.keys(callsByEmployee).forEach(function(k) {
          let c = _.countBy(callsByEmployee[k], 'Status');
          let employeeName = _this.employees.filter(e => e.EmployeeID === k)[0].Name;
          let d = _.clone(_this.preAuthOutstandingStatuses);
          _.merge(d, c);

          // Calculate conversion
          let allCallsByThisEmp = callsByEmployee[k].length;
          let allCallsReceivedByThisEmp = _this.preAuthOutstandingClaimReceivedDataWeekly.filter(c => c.CreatedByEmpID === k);
          let allCallsReceivedByThisEmpLength = allCallsReceivedByThisEmp.length;
          let conversionRate = Math.ceil((allCallsReceivedByThisEmpLength / allCallsByThisEmp) * 100);
          let o = {
            name: employeeName,
            totalCalls: _.sum(_.values(d)),
            totalReceived: allCallsReceivedByThisEmpLength,
            conversionRate: conversionRate,
            chartData: _this.makeChartDataWeekly(_this.preAuthOutstandingTasksDataWeekly, allCallsReceivedByThisEmp, k, true, false)
          }
          ret.push(o);
        });
        return ret;
      }
    },

    preAuthOutstandingDataMonthlyByEmp() {
      if(this.preAuthOutstandingTasksDataMonthly && this.preAuthOutstandingStatuses && this.employees) {
        let ret = [];
        let callsByEmployee = _.groupBy(this.preAuthOutstandingTasksDataMonthly, "CreatedByEmpID");
        var _this = this;
        _.keys(callsByEmployee).forEach(function(k) {
          let c = _.countBy(callsByEmployee[k], 'Status');
          let employeeName = _this.employees.filter(e => e.EmployeeID === k)[0].Name;
          let d = _.clone(_this.preAuthOutstandingStatuses);
          _.merge(d, c);

          // Calculate conversion
          let allCallsByThisEmp = callsByEmployee[k].length;
          let allCallsReceivedByThisEmp = _this.preAuthOutstandingClaimReceivedDataMonthly.filter(c => c.CreatedByEmpID === k);
          let allCallsReceivedByThisEmpLength = allCallsReceivedByThisEmp.length;
          let conversionRate = Math.ceil((allCallsReceivedByThisEmpLength / allCallsByThisEmp) * 100);
          let o = {
            name: employeeName,
            totalCalls: _.sum(_.values(d)),
            totalReceived: allCallsReceivedByThisEmpLength,
            conversionRate: conversionRate,
            chartData: _this.makeChartDataMonthly(_this.preAuthOutstandingTasksDataMonthly, allCallsReceivedByThisEmp, k, true, false)
          }
          ret.push(o);
        });
        return ret;
      }
    },

    preAuthReceivedDataDailyByEmp() {
      if(this.preAuthReceivedTasksDataDaily && this.preAuthReceivedStatuses && this.employees) {
        let ret = [];
        let temp = _.groupBy(this.preAuthReceivedTasksDataDaily, "CreatedByEmpID");
        var _this = this;
        _.keys(temp).forEach(function(k) {
          let c = _.countBy(temp[k], 'Status');
          let employeeName = _this.employees.filter(e => e.EmployeeID === k)[0].Name;
          let d = _.clone(_this.preAuthReceivedStatuses);
          _.merge(d, c);
          let o = {
            name: employeeName,
            totalCalls: _.sum(_.values(d)),
            chartData: _this.makeChartData(d)
          }
          ret.push(o);
        });
        return ret;
      }
    },

    preAuthReceivedDataWeeklyByEmp() {
      if(this.preAuthReceivedTasksDataWeekly && this.preAuthReceivedStatuses && this.employees) {
        let ret = [];
        let callsByEmployee = _.groupBy(this.preAuthReceivedTasksDataWeekly, "CreatedByEmpID");
        var _this = this;
        _.keys(callsByEmployee).forEach(function(k) {
          let c = _.countBy(callsByEmployee[k], 'Status');
          let employeeName = _this.employees.filter(e => e.EmployeeID === k)[0].Name;
          let d = _.clone(_this.preAuthReceivedStatuses);
          _.merge(d, c);

          // Calculate conversion
          let allCallsByThisEmp = callsByEmployee[k].length;
          let allCallsScheduledByThisEmp = _this.preAuthReceivedScheduledDataWeekly.filter(c => c.CreatedByEmpID === k);
          let allCallsScheduledByThisEmpLength = allCallsScheduledByThisEmp.length;
          let conversionRate = Math.ceil((allCallsScheduledByThisEmpLength / allCallsByThisEmp) * 100);
          let o = {
            name: employeeName,
            totalCalls: _.sum(_.values(d)),
            conversionRate: conversionRate,
            chartData: _this.makeChartDataWeekly(_this.preAuthReceivedTasksDataWeekly, allCallsScheduledByThisEmp, k, false, false)
           }
          ret.push(o);
        });
        return ret;
      }
    },

    preAuthReceivedDataMonthlyByEmp() {
      if(this.preAuthReceivedTasksDataMonthly && this.preAuthReceivedStatuses && this.employees) {
        let ret = [];
        let callsByEmployee = _.groupBy(this.preAuthReceivedTasksDataMonthly, "CreatedByEmpID");
        var _this = this;
        _.keys(callsByEmployee).forEach(function(k) {
          let c = _.countBy(callsByEmployee[k], 'Status');
          let employeeName = _this.employees.filter(e => e.EmployeeID === k)[0].Name;
          let d = _.clone(_this.preAuthReceivedStatuses);
          _.merge(d, c);

          // Calculate conversion
          let allCallsByThisEmp = callsByEmployee[k].length;
          let allCallsScheduledByThisEmp = _this.preAuthReceivedScheduledDataMonthly.filter(c => c.CreatedByEmpID === k);
          let allCallsScheduledByThisEmpLength = allCallsScheduledByThisEmp.length;
          let conversionRate = Math.ceil((allCallsScheduledByThisEmpLength / allCallsByThisEmp) * 100);
          let o = {
            name: employeeName,
            totalCalls: _.sum(_.values(d)),
            conversionRate: conversionRate,
            chartData: _this.makeChartDataMonthly(_this.preAuthReceivedTasksDataMonthly, allCallsScheduledByThisEmp, k, false, false)
          }
          ret.push(o);
        });
        return ret;
      }
    },

    patientBalancesDataDailyByEmp() {
      if(this.patientBalancesTasksDataDaily && this.patientBalancesStatuses && this.employees) {
        let ret = [];
        let temp = _.groupBy(this.patientBalancesTasksDataDaily, "CreatedByEmpID");
        var _this = this;
        _.keys(temp).forEach(function(k) {
          let c = _.countBy(temp[k], 'Status');
          let employeeName = _this.employees.filter(e => e.EmployeeID === k)[0].Name;
          let d = _.clone(_this.patientBalancesStatuses);
          _.merge(d, c);
          let o = {
            name: employeeName,
            totalCalls: _.sum(_.values(d)),
            chartData: _this.makeChartData(d)
          }
          ret.push(o);
        });
        return ret;
      }
    },

    patientBalancesDataWeeklyByEmp() {
      if(this.patientBalancesTasksDataWeekly && this.patientBalancesStatuses && this.employees) {
      //if(this.patientBalancesTasksDataWeekly && this.patientBalancesStatuses && this.patientBalancesPaidWeekly && this.employees) {
        let ret = [];
        let callsByEmployee = _.groupBy(this.patientBalancesTasksDataWeekly, "CreatedByEmpID");
        var _this = this;
        _.keys(callsByEmployee).forEach(function(k) {
          let c = _.countBy(callsByEmployee[k], 'Status');
          let employeeName = _this.employees.filter(e => e.EmployeeID === k)[0].Name;
          let d = _.clone(_this.patientBalancesStatuses);
          _.merge(d, c);

          // Calculate conversion
          let allCallsByThisEmp = callsByEmployee[k].length;
          let allCallsPaidByThisEmp = null;
          let allCallsPaidByThisEmpLength = 0;
          let conversionRate = 0;
          //let allCallsPaidByThisEmp = _this.patientBalancesPaidWeekly.filter(c => c.CreatedByEmpID === k);
          //let allCallsPaidByThisEmpLength = allCallsPaidByThisEmp.length;
          //let conversionRate = Math.ceil((allCallsPaidByThisEmpLength / allCallsByThisEmp) * 100);
          let o = {
            name: employeeName,
            totalCalls: _.sum(_.values(d)),
            conversionRate: conversionRate,
            chartData: _this.makeChartDataWeekly(_this.patientBalancesTasksDataWeekly, allCallsPaidByThisEmp, k, false, true)
          }
          ret.push(o);
        });
        return ret;
      }
    },

    patientBalancesDataMonthlyByEmp() {
      if(this.patientBalancesTasksDataMonthly && this.patientBalancesStatuses && this.employees) {
        let ret = [];
        let callsByEmployee = _.groupBy(this.patientBalancesTasksDataMonthly, "CreatedByEmpID");
        var _this = this;
        _.keys(callsByEmployee).forEach(function(k) {
          let c = _.countBy(callsByEmployee[k], 'Status');
          let employeeName = _this.employees.filter(e => e.EmployeeID === k)[0].Name;
          let d = _.clone(_this.patientBalancesStatuses);
          _.merge(d, c);

          // Calculate conversion
          let allCallsByThisEmp = callsByEmployee[k].length;
          let allCallsPaidByThisEmp = null;
          let allCallsPaidByThisEmpLength = 0;
          let conversionRate = 0;
          //let allCallsPaidByThisEmp = _this.patientBalancesPaidMonthly.filter(c => c.CreatedByEmpID === k);
          //let allCallsPaidByThisEmpLength = allCallsPaidByThisEmp.length;
          //let conversionRate = Math.ceil((allCallsPaidByThisEmpLength / allCallsByThisEmp) * 100);
          let o = {
            name: employeeName,
            totalCalls: _.sum(_.values(d)),
            conversionRate: conversionRate,
            chartData: _this.makeChartDataMonthly(_this.patientBalancesTasksDataMonthly, allCallsPaidByThisEmp, k, false, true)
          }
          ret.push(o);
        });
        return ret;
      }
    },

    brokenAppointmentDataDailyByEmp() {
      if(this.brokenAppointmentDataDaily && this.brokenAppointmentStatuses && this.employees) {
        let ret = [];
        let temp = _.groupBy(this.brokenAppointmentTasksDataDaily, "CreatedByEmpID");
        var _this = this;
        _.keys(temp).forEach(function(k) {
          let c = _.countBy(temp[k], 'Status');
          let employeeName = _this.employees.filter(e => e.EmployeeID === k)[0].Name;
          let d = _.clone(_this.brokenAppointmentStatuses);
          _.merge(d, c);
          let o = {
            name: employeeName,
            totalCalls: _.sum(_.values(d)),
            chartData: _this.makeChartData(d)
          }
          ret.push(o);
        });
        return ret;
      }
    },

    brokenAppointmentDataWeeklyByEmp() {
      if(this.brokenAppointmentTasksDataWeekly && this.brokenAppointmentStatuses && this.employees) {
        let ret = [];
        let callsByEmployee = _.groupBy(this.brokenAppointmentTasksDataWeekly, "CreatedByEmpID");
        var _this = this;
        _.keys(callsByEmployee).forEach(function(k) {
          let c = _.countBy(callsByEmployee[k], 'Status');
          let employeeName = _this.employees.filter(e => e.EmployeeID === k)[0].Name;
          let d = _.clone(_this.brokenAppointmentStatuses);
          _.merge(d, c);

          // Calculate conversion
          let allCallsByThisEmp = callsByEmployee[k].length;
          //let allCallsScheduledByThisEmp = callsByEmployee[k].filter(c => c.AppointmentScheduled === 1).length;
          let allCallsScheduledByThisEmp = _this.brokenAppointmentScheduledDataWeekly.filter(c => c.CreatedByEmpID === k);
          let allCallsScheduledByThisEmpLength = allCallsScheduledByThisEmp.length;
          let conversionRate = Math.ceil((allCallsScheduledByThisEmpLength / allCallsByThisEmp) * 100);
          let o = {
            name: employeeName,
            totalCalls: _.sum(_.values(d)),
            conversionRate: conversionRate,
            chartData: _this.makeChartDataWeekly(_this.brokenAppointmentTasksDataWeekly, allCallsScheduledByThisEmp, k, false, false)
          }
          ret.push(o);
        });
        return ret;
      }
    },

    brokenAppointmentDataMonthlyByEmp() {
      if(this.brokenAppointmentTasksDataMonthly && this.brokenAppointmentStatuses && this.employees) {
        let ret = [];
        let callsByEmployee = _.groupBy(this.brokenAppointmentTasksDataMonthly, "CreatedByEmpID");
        var _this = this;
        _.keys(callsByEmployee).forEach(function(k) {
          let c = _.countBy(callsByEmployee[k], 'Status');
          let employeeName = _this.employees.filter(e => e.EmployeeID === k)[0].Name;
          let d = _.clone(_this.brokenAppointmentStatuses);
          _.merge(d, c);

          // Calculate conversion
          let allCallsByThisEmp = callsByEmployee[k].length;
          let allCallsScheduledByThisEmp = _this.brokenAppointmentScheduledDataMonthly.filter(c => c.CreatedByEmpID === k);
          let allCallsScheduledByThisEmpLength = allCallsScheduledByThisEmp.length;
          let conversionRate = Math.ceil((allCallsScheduledByThisEmpLength / allCallsByThisEmp) * 100);
          let o = {
            name: employeeName,
            totalCalls: _.sum(_.values(d)),
            conversionRate: conversionRate,
            chartData: _this.makeChartDataMonthly(_this.brokenAppointmentTasksDataMonthly, allCallsScheduledByThisEmp, k, false, false)
          }
          ret.push(o);
        });
        return ret;
      }
    },

    /*
        ==========================  OLD FAKE DATA =============================
    

    getTodayOverdueRecallChartData() {
      return {
        labels: ["Still processing", "Processed", "NOT received - RESEND",
        "Need more info","Processed"],
        datasets: [
          {
            label: "Data One",
            backgroundColor: ['#3abf94', '#5cc9a7', '#2d9a77', '#14b8a6', '#0d9488'],
            data: [10, 12, 15, 6,7]
          }
        ]
      }
    },

    getTodayAgingOutstandingClaimChartData() {
      return {
        labels: ["Still processing", "Processed", "NOT received - RESEND",
        "Need more info","Processed"],
        datasets: [
          {
            label: "Data One",
            backgroundColor: ['#3abf94', '#5cc9a7', '#2d9a77', '#14b8a6', '#0d9488'],
            data: [10, 12, 15, 6,7]
          }
        ]
      }
    },
    getTodayAgaingPreAuthChartData(){
      return {
        labels: ["Processing", "Processed", "Need Info"],
        datasets: [
          {
            label: "Data One",
            backgroundColor: ['#64748b', '#3abf94', '#14b8a6'],
            data: [10, 12, 15]
          }
        ]
      }
    },
    getTodayInsuranceVerificationChartData() {
      return {
        minX: new Date().setHours(0,0,0,0),
        maxX: new Date().setHours(23,59,0,0),
        data:[{
        label: 'Linda Davies (2)',
        data:  [[new Date().setHours(11,0,0,0), 120]],
        bars: {
          show: true,
          barWidth: 12 * 24 * 80 * 80 * 2,
          fill: 0.5,
          lineWidth: 0,
          order: 1,
        },
      },{
        label: 'Trisha Jones (1)',
        data: [[new Date().setHours(13,0,0,0), 90]],
        bars: {
          show: true,
          barWidth: 12 * 24 * 80 * 80 * 2,
          fill: 0.5,
          lineWidth: 0,
          order: 1,
        },
      }, ]

      }
    },
    getTodayAgingPatientBalanceChartData() {
       return {
        labels: ["Left voicemail & Mailed Stmt", "Mailed Statement", "Spoke with patient"],
        datasets: [
          {
            label: "Data One",
            backgroundColor: ['#64748b', '#3abf94', '#14b8a6'],
            data: [10, 12, 15]
          }
        ]
      }
    },
    getWeekToDateBarChartData1() {
     return { ticks: [[5,'Day 1'],[10, 'Day 2'], [15, 'Day 3'], [20, 'Day 4']],
      data: [{
        label: 'Call',
        data: [[5, 110], [10, 120], [15, 120], [20, 100]],
        bars: {
          show: true,
          fill: 0.5,
          lineWidth: 0,
          order: 1,
        },
      }, {
        label: 'Scheduled',
        data:  [[5, 90], [10, 80], [15, 20], [20, 60]],
        bars: {
          show: true,
          fill: 0.5,
          lineWidth: 0,
          order: 2,
        },
      }]}
    },
    getWeekToDateBarChartData2(){
      return { ticks: [[5,'Day 1'],[10, 'Day 2'], [15, 'Day 3'], [20, 'Day 4']],
        data: [{
          label: 'Call',
          data: [[5, 110], [10, 120], [15, 120], [20, 100]],
          bars: {
            show: true,
            fill: 0.5,
            lineWidth: 0,
            order: 1,
          },
        }, {
          label: 'Processed',
          data:  [[5, 90], [10, 80], [15, 20], [20, 60]],
          bars: {
            show: true,
            fill: 0.5,
            lineWidth: 0,
            order: 2,
          },
        }]}
    },
    getWeekToDateBarChartData3(){
      return { ticks: [[5,'Day 1'],[10, 'Day 2'], [15, 'Day 3'], [20, 'Day 4']],
        data: [{
          label: 'Linda Davies (12)',
          data: [[5, 110], [10, 120], [15, 120], [20, 80]],
          bars: {
            show: true,
            fill: 0.5,
            lineWidth: 0,
            order: 1,
          },
        }, {
          label: 'Trisha Jones (3)',
          data:  [[5, 90], [10, 80], [15, 20], [20, 60]],
          bars: {
            show: true,
            fill: 0.5,
            lineWidth: 0,
            order: 2,
          },
        }]}
    },
    getWeekToDateBarChartData4(){
      return { ticks: [[5,'Day 1'],[10, 'Day 2'], [15, 'Day 3'], [20, 'Day 4']],
        data: [{
          label: 'Follow-ups',
          data: [[5, 110], [10, 120], [15, 120], [20, 80]],
          bars: {
            show: true,
            fill: 0.5,
            lineWidth: 0,
            order: 1,
          },
        }, {
          label: 'Paid',
          data:  [[5, 90], [10, 80], [15, 20], [20, 60]],
          bars: {
            show: true,
            fill: 0.5,
            lineWidth: 0,
            order: 2,
          },
        }]}
    },

    getMonthToDateBarChartData1(){
      return { ticks: [[5,'Week 1'],[10, 'Week 2'], [15, 'Week 3'], [20, 'Week 4']],
      data: [{
        label: 'Calls',
        data: [[5, 55], [10, 55], [15, 45], [20, 55]],
        bars: {
          show: true,
          fill: 0.5,
          lineWidth: 0,
          order: 1,
        },
      }, {
        label: 'Scheduled',
        data:  [[5, 8], [10, 8], [15, 6], [20, 6]],
        bars: {
          show: true,
          fill: 0.5,
          lineWidth: 0,
          order: 2,
        },
      }]}
    },
    getMonthToDateBarChartData2(){
      return { ticks: [[5,'Week 1'],[10, 'Week 2'], [15, 'Week 3'], [20, 'Week 4']],
      data: [{
        label: 'Calls',
        data: [[5, 55], [10, 55], [15, 45], [20, 55]],
        bars: {
          show: true,
          fill: 0.5,
          lineWidth: 0,
          order: 1,
        },
      }, {
        label: 'Processed',
        data:  [[5, 8], [10, 8], [15, 6], [20, 6]],
        bars: {
          show: true,
          fill: 0.5,
          lineWidth: 0,
          order: 2,
        },
      }]}
    },
    getMonthToDateBarChartData3(){
      return { ticks: [[5,'Week 1'],[10, 'Week 2'], [15, 'Week 3'], [20, 'Week 4']],
        data: [{
          label: 'Linda Davies (30)',
          data: [[5, 110], [10, 120], [15, 120], [20, 80]],
          bars: {
            show: true,
            fill: 0.5,
            lineWidth: 0,
            order: 1,
          },
        }, {
          label: 'Trisha Jones (10)',
          data:  [[5, 90], [10, 80], [15, 20], [20, 60]],
          bars: {
            show: true,
            fill: 0.5,
            lineWidth: 0,
            order: 2,
          },
        }]}
    },
    getMonthToDateBarChartData4() {
       return { ticks: [[5,'Week 1'],[10, 'Week 2'], [15, 'Week 3'], [20, 'Week 4']],
      data: [{
        label: 'Follow-ups',
        data: [[5, 55], [10, 55], [15, 45], [20, 55]],
        bars: {
          show: true,
          fill: 0.5,
          lineWidth: 0,
          order: 1,
        },
      }, {
        label: 'Paid',
        data:  [[5, 8], [10, 8], [15, 6], [20, 6]],
        bars: {
          show: true,
          fill: 0.5,
          lineWidth: 0,
          order: 2,
        },
      }]}
    }
    */
  },

  watch: {
    allSettings(newValue, oldValue) {        
      //console.log(`watch changed. Old value: ${JSON.stringify(oldValue)}, \n New value: ${JSON.stringify(newValue)}`);
      if(!oldValue) {
        this.init();
      }        
    }
  }
}
</script>
<style src="./TeamInsightsModern.scss" lang="scss" />